<template>
    <!-- v-loading="loading" -->
    <div class="editor" v-show="!loading" v-on:keyup.enter="changeObjectDimensions" @drop="onDrop($event, 12)">

        <div id="cotw" style="position:absolute; left: 50%; top:50%;z-index:999; display:none;">
            <div><img src="https://editor.alstar.ch/rand.gif" /></div>
        </div>

        <!-- side tab -->
        <div class="menu-tab" v-if="tab && !loading">
            <!-- fonts tab -->
            <div v-if="fontsDialog" class="fonts-dialog">
                <div class="fonts-dialog-header">
                    <i class="close-fonts el-icon-close" v-on:click="fontsDialog = false"></i>
                </div>
                <div class="fonts-dialog-items">
                    <div class="font-item" v-for="(font, index) in fonts" :key="index" v-html="font.svgPreview"
                         v-on:click="setStyle({fontFamily: font.name}); fontsDialog = false">
                    </div>
                </div>
            </div>
            <!-- text tab -->
            <div class="tab" v-if="tab === 'text' && activeTab">
                <el-button plain v-on:click="addText({fontSize:40, text: language.addHeadingText})"
                           style="margin-bottom: 20px; text-align:left; width:100%; margin-left:0px; padding-left:10px; font-size:16pt; color: val(--secondary-color); font-weight:bold;">
                    {{language.addHeadingText}}
                </el-button>
                <el-button plain v-on:click="addText({fontSize:25, text: language.addSubheadingText})"
                           style="margin-bottom: 20px; text-align: left; width: 100%; margin-left: 0px; padding-left: 10px; font-size: 11pt; color: val(--secondary-color); font-weight: bold;">
                    {{language.addSubheadingText}}
                </el-button>
                <el-button plain v-on:click="addText({fontSize:12,  text: language.addBodyText})"
                           style="margin-bottom: 20px; text-align: left; width: 100%; margin-left: 0px; padding-left: 10px; font-size: 8pt; color: val(--secondary-color); font-weight: bold;">
                    {{language.addBodyText}}
                </el-button>
            </div>
            <!-- pages tab -->
            <div class="tab" v-if="tab === 'pages' && !activeSelection">
                <div class="pages-container"
                     style="display:flex; flex-direction:row; flex-wrap: wrap; justify-content:space-between;">
                    <div class="page-item" v-on:click="pageDialog = true; pageForm.fill = '#ffffff'">
                        <div style="width:100%; height: 100%; position:relative; display:flex; justify-content:center; align-items:center; color:var(--primary-color); font-size:10pt;">
                            <el-button size="supermini" type="primary" icon="el-icon-plus" circle
                                       style="position:absolute; top:-12.5px; right:-12.5px; font-size:12px;"></el-button>
                            {{language.newPage}}
                        </div>
                    </div>
                    <div v-for="(page, index) in pages" :key="index"
                         v-bind:class="{ 'active-page': index === activePage, 'page-item' : true }"
                         v-on:click="setPage(index)" v-bind:style="{background: page.fill}">
                        <div style="width:100%; height: 100%; position:relative; display:flex; justify-content:center; align-items:center; font-size:10pt;">
                            <el-button v-if="index === activePage" v-on:click.prevent="removePage(index)"
                                       size="supermini" type="danger" icon="el-icon-delete" circle
                                       style="position:absolute; top:-12.5px; right:-12.5px; font-size:12px;">
                            </el-button>
                            {{page.width}}x{{page.height}} <br />
                            {{page.name}}
                        </div>
                    </div>
                </div>
            </div>
            <!-- images tab -->
            <div class="tab" v-if="tab === 'images' && activeTab">
                <el-upload drag :before-upload="uploadImageBase64" accept=".jpg,.jpeg,.png,.JPG,.JPEG,.svg,.SVG,.json,.JSON,.pdf,.PDF"
                           action="#">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        {{language.uploadText}} <br><em>{{language.uploadTextAccented}}</em>
                    </div>
                    <div class="el-upload__tip" slot="tip">{{language.uploadTextSmall}}</div>
                </el-upload>
            </div>
            <!-- shapes tab -->
            <div class="tab" v-if="tab === 'shapes' && activeTab">
                <el-row type="flex" justify="space-between" style="margin-bottom:20px;">
                    <el-col :span="24">
                        <el-collapse v-model="activeNames">
                            <el-collapse-item :title="language.shapesHeader" name="1">
                                <div class="shapes-container-div">
                                    <el-row type="flex" justify="space-between" style="margin-bottom:20px;">
                                        <el-col :span="6">
                                            <svg v-on:click="addCircle" xmlns="http://www.w3.org/2000/svg"
                                                 width="44" height="44">
                                                <circle fill="#000" cx="22" cy="22" r="22"></circle>
                                            </svg>
                                        </el-col>
                                        <el-col :span="6">
                                            <svg v-on:click="addTriangle"
                                                 xmlns="http://www.w3.org/2000/svg" width="44" height="44">
                                                <polygon fill="#000" points="0,44 22,0 44,44"></polygon>
                                            </svg>
                                        </el-col>
                                        <el-col :span="6">
                                            <svg v-on:click="addRect" xmlns="http://www.w3.org/2000/svg" width="44"
                                                 height="44">
                                                <rect fill="#000" width="44" height="44"></rect>
                                            </svg>
                                        </el-col>
                                    </el-row>
                                    <el-row type="flex" justify="space-between" style="margin-bottom:20px;">
                                        <el-col :span="6" v-on:click="addEllipse">
                                            <svg v-on:click="addEllipse"
                                                 xmlns="http://www.w3.org/2000/svg" width="44" height="44">
                                                <ellipse fill="#000" cx="22" cy="22" ry="15" rx="22"></ellipse>
                                            </svg>
                                        </el-col>
                                        <el-col :span="6">
                                            <img v-on:click="addPath('https://editor.alstar.ch/shapes/shape0.svg');" src="https://editor.alstar.ch/shapes/shape0.svg" width="44" height="44" />
                                        </el-col>
                                        <el-col :span="6">
                                            <img v-on:click="addPath('https://editor.alstar.ch/shapes/shape1.svg');" src="https://editor.alstar.ch/shapes/shape1.svg" width="44" height="44" />
                                        </el-col>
                                    </el-row>
                                    <el-row type="flex" justify="space-between" style="margin-bottom:0px;">
                                        <el-col :span="6">
                                            <img v-on:click="addPath('https://editor.alstar.ch/shapes/shape2.svg');" src="https://editor.alstar.ch/shapes/shape2.svg" width="44" height="44" />
                                        </el-col>
                                        <el-col :span="6">
                                            <img v-on:click="addPath('https://editor.alstar.ch/shapes/shape3.svg');" src="https://editor.alstar.ch/shapes/shape3.svg" width="44" height="44" />
                                        </el-col>
                                        <el-col :span="6">
                                            <img v-on:click="addPath('https://editor.alstar.ch/shapes/shape4.svg');" src="https://editor.alstar.ch/shapes/shape4.svg" width="44" height="44" />
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </el-col>
                </el-row>
            </div>

            <!-- cliparts/illustrations/fotos/backgrounds tab -->
            <div class="tab" v-if="(tab === 'cliparts' || tab === 'illustrations' || tab === 'fotos' || tab === 'backgrounds' || tab === 'cp_0' || tab === 'cp_1' || tab === 'cp_2' || tab === 'cp_3' || tab === 'cp_4' || tab === 'cp_5' ) && activeTab">
                <el-row type="flex" justify="space-between" class="active-tab-row" v-if="tab === 'backgrounds' && activeTab">
                    <el-col :span="6" class="tab-col">
                        {{language.textColor}}
                    </el-col>
                    <el-col :span="4">
                        <el-color-picker :value="backgroundFill" size="medium" @change="setPageBackground($event)" />
                    </el-col>
                </el-row>
                <el-row type="flex" justify="space-between" style="margin-bottom:10px;">
                    <el-col :span="24">
                        <el-collapse v-model="activeNames" accordion>
                            <el-collapse-item :title="getRightName(clipart.category)" :name="index" v-for="(clipart, index) in arrayFromTab" :key="index" v-bind:data-tab="tab" v-bind:data-ix="index">
                                <div class="cliparts-all">
                                    <div v-for="(file, i) in clipart.files" :key="i" class="clipart-one">
                                        <image-item class="clipart-image clipart-item clipart-fisch"
                                                    v-if="file.url"
                                                    :source-original="hostUrl + '/' + file.url"
                                                    :source-thumb="`${hostUrl}/${file.thumbNameUrl}`"
                                                    @imageClick="imageClick" />
                                    </div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </el-col>
                </el-row>
                <el-row type="flex" v-if="tab === 'backgrounds' && activeTab">
                    <el-col :span="24" style="display:flex; justify-content:flex-end;">
                        <el-button-group>
                            <el-tooltip class="item" effect="dark" :content="language.delete" placement="top">
                                <el-button size="supermini" icon="el-icon-delete" plain v-on:click="deleteSelection(true)">
                                </el-button>
                            </el-tooltip>
                        </el-button-group>
                    </el-col>
                </el-row>
            </div>

            <!-- farben tab -->
            <div class="tab" v-if="tab === 'farben' && activeTab">
                <el-row type="flex" justify="space-between" class="active-tab-row">
                    <el-col :span="6" class="tab-col">
                        {{language.textColor}}
                    </el-col>
                    <el-col :span="4">
                        <el-color-picker :value="backgroundFill" size="medium" @change="setPageBackground($event)" />
                    </el-col>
                </el-row>
            </div>

            <!-- utils tab -->
            <div class="tab" v-if="tab === 'utils' && activeTab">
                <el-row type="flex" justify="space-between"
                        style="margin-bottom:10px; border-bottom:1px solid #373842; align-items:center; padding-bottom:10px;">
                    <el-col :span="14" style="font-size:10pt; color:#EDEDED;">
                        {{language.ruler}}
                    </el-col>
                    <el-col :span="4">
                        <el-switch v-model="ruler" active-color="var(--primary-color)" inactive-color="#373842">
                        </el-switch>
                    </el-col>
                </el-row>
                <el-row type="flex" justify="space-between"
                        style="margin-bottom:10px; border-bottom:1px solid #373842; align-items:center; padding-bottom:10px;">
                    <el-col :span="14" style="font-size:10pt; color:#EDEDED;">
                        {{language.gridLines}}
                    </el-col>
                    <el-col :span="4">
                        <el-switch v-model="grid" v-on:change="setGrid" active-color="var(--primary-color)" inactive-color="#373842">
                        </el-switch>
                    </el-col>
                </el-row>
                <el-row type="flex" justify="space-between"
                        style="margin-bottom:10px; border-bottom:1px solid #373842; align-items:center; padding-bottom:10px;">
                    <el-col :span="10" style="font-size:10pt; color:#EDEDED;">
                        {{language.gridSize}}
                    </el-col>
                    <el-col :span="13">
                        <el-slider :value="gridSize" v-on:input="setGridSize" :min="3" :max="50" :show-tooltip="false">
                        </el-slider>
                    </el-col>
                </el-row>
            </div>

            <!-- special tab -->
            <div class="tab" v-if="tab === 'special' && activeTab">
                <div v-html="specialtab.content">
                </div>
            </div>

            <!-- activeSelection edit -->
            <div style="padding: 20px 20px 0px 20px; display: flex; flex-direction: column; width: calc(100% - 40px);}"
                 v-if="activeSelection && typeof activePage === 'number'">

                <!-- text -->
                <div v-if="activeSelection.type === 'InteractiveText'">
                    <el-row type="flex" justify="space-between"
                            style="margin-bottom:10px; border-bottom:1px solid #373842; align-items:center; padding-bottom:10px;">
                        <el-col :span="10" style="font-size:10pt; color:#EDEDED;">
                            {{language.textFontFamily}}
                        </el-col>
                        <el-col :span="14">
                            <div>
                                <div class="font-select" v-on:click="fontsDialog = true">
                                    {{activeSelection.fontFamily}}
                                </div>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row type="flex" justify="space-between"
                            style="margin-bottom:10px; border-bottom:1px solid #373842; align-items:center; padding-bottom:10px;">
                        <el-col :span="12" style="font-size:10pt; color:#EDEDED;">
                            {{language.textFontSize}}
                        </el-col>
                        <el-col :span="9">
                            <div>
                                <el-select allow-create filterable v-model="activeSelectionValue"
                                           v-on:change="setStyle({fontSize: $event})" placeholder="35">
                                    <el-option v-for="(value, index) in fontSizes" :key="index" :label="value" :value="value"></el-option>
                                </el-select>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row type="flex" justify="space-between"
                            style="margin-bottom:10px; border-bottom:1px solid #373842; align-items:center; padding-bottom:10px;">
                        <el-col :span="6" style="font-size:10pt; color:#EDEDED;">
                            {{language.textColor}}
                        </el-col>
                        <el-col :span="4">
                            <el-color-picker :value="activeSelection.fill" size="medium" style="margin-left:4px;"
                                             v-on:change="setStyle({fill: $event})"></el-color-picker>
                        </el-col>
                    </el-row>
                    <el-row type="flex" justify="space-between"
                            style="margin-bottom:10px; border-bottom:1px solid #373842; align-items:center; padding-bottom:10px;">
                        <el-col :span="8" style="font-size:10pt; color:#EDEDED;">
                            {{language.textAlign}}
                        </el-col>
                        <el-col :span="13">
                            <el-button-group style="margin-left:6px">
                                <el-tooltip class="item" effect="dark" :content="language.left" placement="top">
                                    <el-button size="supermini" plain
                                               v-bind:class="{ active: activeSelection.lineAlign === 'left' }"
                                               v-on:click="setStyle({textAlign: 'left'})">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                             viewBox="0 0 24 24">
                                            <path fill="currentColor"
                                                  d="M3.75 5.25h16.5a.75.75 0 1 1 0 1.5H3.75a.75.75 0 0 1 0-1.5zm0 4h8.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5zm0 4h16.5a.75.75 0 1 1 0 1.5H3.75a.75.75 0 1 1 0-1.5zm0 4h8.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5z">
                                            </path>
                                        </svg>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" :content="language.center" placement="top">
                                    <el-button size="supermini" plain
                                               v-bind:class="{ active: activeSelection.lineAlign === 'center' }"
                                               v-on:click="setStyle({textAlign: 'center'})">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                             viewBox="0 0 24 24">
                                            <path fill="currentColor" fill-rule="evenodd"
                                                  d="M3.75 5.25h16.5a.75.75 0 1 1 0 1.5H3.75a.75.75 0 0 1 0-1.5zm4 4h8.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5zm-4 4h16.5a.75.75 0 1 1 0 1.5H3.75a.75.75 0 1 1 0-1.5zm4 4h8.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5z">
                                            </path>
                                        </svg>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" :content="language.right" placement="top">
                                    <el-button size="supermini" plain
                                               v-bind:class="{ active: activeSelection.lineAlign === 'right' }"
                                               v-on:click="setStyle({textAlign: 'right'})">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                             viewBox="0 0 24 24">
                                            <path fill="currentColor" fill-rule="evenodd"
                                                  d="M20.25 5.25a.75.75 0 1 1 0 1.5H3.75a.75.75 0 0 1 0-1.5h16.5zm0 4a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zm0 4a.75.75 0 1 1 0 1.5H3.75a.75.75 0 1 1 0-1.5h16.5zm0 4a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5z">
                                            </path>
                                        </svg>
                                    </el-button>
                                </el-tooltip>
                            </el-button-group>
                        </el-col>
                    </el-row>
                    <el-row type="flex" justify="space-between"
                            style="margin-bottom:10px; border-bottom:1px solid #373842; align-items:center; padding-bottom:10px;">
                        <el-col :span="8" style="font-size:10pt; color:#EDEDED;">
                            {{language.textTracking}}
                        </el-col>
                        <el-col :span="14">
                            <el-slider v-model="activeSelection.tracking" v-on:change="setStyle({tracking: $event})"
                                       :min="-400" :max="400">
                            </el-slider>
                        </el-col>
                    </el-row>
                </div>
                <!-- text -->
                <!-- shape -->
                <div v-if="activeSelection.type === 'triangle' || activeSelection.type === 'circle' || activeSelection.type === 'rect' || activeSelection.type === 'ellipse' || activeSelection.type === 'path'">
                    <el-row type="flex" justify="space-between"
                            style="margin-bottom:10px; border-bottom:1px solid #373842; align-items:center; padding-bottom:10px;">
                        <el-col :span="12" style="font-size:10pt; color:#EDEDED;">
                            {{language.strokeWidth}}
                        </el-col>
                        <el-col :span="9">
                            <div>
                                <el-select allow-create filterable :value="activeSelection.strokeWidth"
                                           v-on:change="setStyle({strokeWidth: $event})" default-first-option>
                                    <el-option v-for="index in 30" :key="index" :label="index / 2" :value="index / 2">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row type="flex" justify="space-between"
                            style="margin-bottom:10px; border-bottom:1px solid #373842; align-items:center; padding-bottom:10px;">
                        <el-col :span="8" style="font-size:10pt; color:#EDEDED;">
                            {{language.strokeColor}}
                        </el-col>
                        <el-col :span="4">
                            <el-color-picker :value="activeSelection.stroke" size="medium" style="margin-left:4px;"
                                             v-on:change="setStyle({stroke: $event})"></el-color-picker>
                        </el-col>
                    </el-row>
                    <el-row type="flex" justify="space-between"
                            style="margin-bottom:10px; border-bottom:1px solid #373842; align-items:center; padding-bottom:10px;">
                        <el-col :span="6" style="font-size:10pt; color:#EDEDED;">
                            {{language.fillColor}}
                        </el-col>
                        <el-col :span="4">
                            <el-color-picker :value="activeSelection.fill" size="medium" style="margin-left:4px;"
                                             v-on:change="setStyle({fill: $event})"></el-color-picker>
                        </el-col>
                    </el-row>
                </div>
                <!-- shape -->

                <el-row type="flex" justify="space-between"
                        style="margin-bottom:10px; border-bottom:1px solid #373842; align-items:center; padding-bottom:10px;">
                    <el-col :span="8" style="font-size:10pt; color:#EDEDED;">
                        {{language.textTransparency}}
                    </el-col>
                    <el-col :span="14">
                        <el-slider v-model="objectTransparensy" v-on:input="setStyle({opacity: $event / 100})">
                        </el-slider>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="space-between"
                        style="margin-bottom:10px; border-bottom:1px solid #373842; align-items:center; padding-bottom:10px;">
                    <el-col :span="8" style="font-size:10pt; color:#EDEDED;">
                        {{language.align}}
                    </el-col>
                    <el-col :span="13">
                        <el-button-group style="margin-bottom:10px; margin-left:6px">
                            <el-tooltip class="item" effect="dark" :content="language.left" placement="top">
                                <el-button size="supermini" plain v-on:click="setAlign('left')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                        <path fill="currentColor"
                                              d="M4 3c.41 0 .75.34.75.75v16.5a.75.75 0 1 1-1.5 0V3.75c0-.41.34-.75.75-.75zm5 3h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2zm0 7h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-1c0-1.1.9-2 2-2zm0-5.5a.5.5 0 0 0-.5.5v1c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5H9zm0 7a.5.5 0 0 0-.5.5v1c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H9z">
                                        </path>
                                    </svg>
                                </el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" :content="language.center" placement="top">
                                <el-button size="supermini" plain v-on:click="setAlign('center')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                        <path fill="currentColor"
                                              d="M11.25 13v-2H7a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2h4.25V3.75a.75.75 0 1 1 1.5 0V6H17a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4.25v2H14a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-1.25v2.25a.75.75 0 1 1-1.5 0V18H10a2 2 0 0 1-2-2v-1c0-1.1.9-2 2-2h1.25zM7 7.5a.5.5 0 0 0-.5.5v1c0 .28.22.5.5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5H7zm3 7a.5.5 0 0 0-.5.5v1c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4z">
                                        </path>
                                    </svg>
                                </el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" :content="language.right" placement="top">
                                <el-button size="supermini" plain v-on:click="setAlign('right')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                        <path fill="currentColor"
                                              d="M20 3a.75.75 0 0 0-.75.75v16.5a.75.75 0 1 0 1.5 0V3.75A.75.75 0 0 0 20 3zm-5 3H6a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h9a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 7h-4a2 2 0 0 0-2 2v1c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2zm0-5.5c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5V8c0-.28.22-.5.5-.5h9zm0 7c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1c0-.28.22-.5.5-.5h4z">
                                        </path>
                                    </svg>
                                </el-button>
                            </el-tooltip>
                        </el-button-group>
                        <el-button-group style="margin-left:6px">
                            <el-tooltip class="item" effect="dark" :content="language.top" placement="top">
                                <el-button size="supermini" plain v-on:click="setAlign('top')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                        <path fill="currentColor"
                                              d="M21 4c0 .41-.34.75-.75.75H3.75a.75.75 0 0 1 0-1.5h16.5c.41 0 .75.34.75.75zM11 9v9a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V9c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2zm7 0v4a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2V9c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2zM9.5 9a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5v9c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V9zm7 0a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V9z">
                                        </path>
                                    </svg>
                                </el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" :content="language.middle" placement="top">
                                <el-button size="supermini" plain v-on:click="setAlign('middle')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                        <path fill="currentColor"
                                              d="M11 11.25h2V7c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2v4.25h2.25a.75.75 0 1 1 0 1.5H18V17a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-4.25h-2V14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-1.25H3.75a.75.75 0 1 1 0-1.5H6V10c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2v1.25zM16.5 7a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V7zm-7 3a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5v-4z">
                                        </path>
                                    </svg>
                                </el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" :content="language.bottom" placement="top">
                                <el-button size="supermini" plain v-on:click="setAlign('bottom')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                        <path fill="currentColor"
                                              d="M21 20c0 .41-.34.75-.75.75H3.75a.75.75 0 1 1 0-1.5h16.5c.41 0 .75.34.75.75zM11 6v9a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2zm7 5v4a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-4c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2zM9.5 6a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5v9c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V6zm7 5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5v-4z">
                                        </path>
                                    </svg>
                                </el-button>
                            </el-tooltip>
                        </el-button-group>
                    </el-col>
                </el-row>
                <el-row type="flex" justify="space-between"
                        style="margin-bottom:10px; border-bottom:1px solid #373842; align-items:center; padding-bottom:10px;">
                    <el-col :span="6" style="font-size:10pt; color:#EDEDED;">
                        {{language.layering}}
                    </el-col>
                    <el-col :span="17">
                        <el-button-group style="margin-left:4px;">
                            <el-tooltip class="item" effect="dark" :content="language.front" placement="top">
                                <el-button size="supermini" plain v-on:click="setLayer('front')">
                                    <svg viewBox="0 0 12 16" width="14" height="14">
                                        <path fill="currentColor"
                                              d="M1.60126 6.87504L6.0444 2.28786L10.3988 6.78264C10.5606 6.94973 10.829 6.94913 10.9901 6.78131L11.8857 5.84851C12.0385 5.6893 12.038 5.4378 11.8846 5.27919L6.95817 0.187666C6.84211 0.0677257 6.68231 -4.64887e-07 6.51536 -4.79483e-07L5.57347 -5.61825e-07C5.4065 -5.76422e-07 5.24669 0.067736 5.13063 0.187694L0.115409 5.37164C-0.0380459 5.53026 -0.0385266 5.78174 0.114322 5.94094L1.00989 6.87374C1.17102 7.04157 1.43939 7.04216 1.60126 6.87504Z">
                                        </path>
                                        <path fill="currentColor"
                                              d="M1.60125 12.8752L4.99993 9.36631L4.99993 15.6001C4.99993 15.821 5.17902 16.0001 5.39993 16.0001L6.59993 16.0001C6.82084 16.0001 6.99993 15.821 6.99993 15.6001L6.99993 9.27432L10.3988 12.7828C10.5606 12.9499 10.829 12.9493 10.9901 12.7814L11.8857 11.8486C12.0385 11.6894 12.038 11.4379 11.8846 11.2793L6.95817 6.18779C6.84211 6.06785 6.68231 6.00012 6.51536 6.00012L5.57347 6.00012C5.4065 6.00012 5.24669 6.06786 5.13063 6.18782L0.115409 11.3718C-0.0380455 11.5304 -0.0385271 11.7819 0.114321 11.9411L1.00989 12.8739C1.17102 13.0417 1.43938 13.0423 1.60125 12.8752Z">
                                        </path>
                                    </svg>
                                </el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" :content="language.forward" placement="top">
                                <el-button size="supermini" plain v-on:click="setLayer('up')">
                                    <svg viewBox="0 0 16 16" width="14" height="14">
                                        <path fill="currentColor"
                                              d="M8.99287 10.4938C8.99287 10.77 8.76901 10.9938 8.49287 10.9938H7.49287C7.21673 10.9938 6.99287 10.77 6.99287 10.4938V4.99384H4.99287C4.79283 4.99103 4.61372 4.86925 4.53755 4.68426C4.46138 4.49927 4.50281 4.28669 4.64287 4.14384L7.64287 1.14384C7.84068 0.952054 8.15505 0.952054 8.35287 1.14384L11.3529 4.14384C11.4942 4.28799 11.5349 4.50297 11.4562 4.68884C11.3775 4.87472 11.1947 4.99502 10.9929 4.99384H8.99287V10.4938Z">
                                        </path>
                                        <path fill="currentColor"
                                              d="M3.77352 10.8208L5.49291 9.74613V7.38764L1.35672 9.97276C0.730051 10.3644 0.730052 11.2771 1.35672 11.6688L7.46992 15.4895C7.7942 15.6922 8.20565 15.6922 8.52992 15.4895L14.6431 11.6688C15.2698 11.2771 15.2698 10.3644 14.6431 9.97275L10.4929 7.37887V9.73736L12.2263 10.8208L7.99992 13.4623L3.77352 10.8208Z">
                                        </path>
                                    </svg>
                                </el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" :content="language.backward" placement="top">
                                <el-button size="supermini" plain v-on:click="setLayer('down')">
                                    <svg viewBox="0 0 16 16" width="14" height="14">
                                        <path fill="currentColor"
                                              d="M7.00698 6.14767C7.00698 5.87153 7.23083 5.64767 7.50698 5.64767H8.50698C8.78312 5.64767 9.00698 5.87153 9.00698 6.14767L9.00698 11.6477H11.007C11.207 11.6505 11.3861 11.7723 11.4623 11.9572C11.5385 12.1422 11.497 12.3548 11.357 12.4977L8.35698 15.4977C8.15916 15.6895 7.84479 15.6895 7.64698 15.4977L4.64698 12.4977C4.50567 12.3535 4.46491 12.1385 4.54363 11.9527C4.62236 11.7668 4.80512 11.6465 5.00698 11.6477H7.00698L7.00698 6.14767Z">
                                        </path>
                                        <path fill="currentColor"
                                              d="M12.2263 5.82075L10.5069 6.89537V9.25387L14.6431 6.66875C15.2698 6.27708 15.2698 5.36442 14.6431 4.97275L8.52992 1.152C8.20565 0.949333 7.79419 0.949333 7.46992 1.152L1.35672 4.97275C0.730051 5.36442 0.730052 6.27708 1.35672 6.66875L5.50694 9.26264V6.90414L3.77352 5.82075L7.99992 3.17925L12.2263 5.82075Z">
                                        </path>
                                    </svg>
                                </el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" :content="language.back" placement="top">
                                <el-button size="supermini" plain v-on:click="setLayer('back')">
                                    <svg viewBox="0 0 12 16" width="14" height="14">
                                        <path fill="currentColor"
                                              d="M10.3987 9.12508L5.9556 13.7123L1.60124 9.21748C1.43936 9.05039 1.17102 9.05099 1.0099 9.21881L0.114321 10.1516C-0.0385337 10.3108 -0.0380454 10.5623 0.115427 10.7209L5.04183 15.8125C5.15789 15.9324 5.31769 16.0001 5.48464 16.0001H6.42653C6.5935 16.0001 6.75331 15.9324 6.86937 15.8124L11.8846 10.6285C12.038 10.4699 12.0385 10.2184 11.8857 10.0592L10.9901 9.12638C10.829 8.95855 10.5606 8.95796 10.3987 9.12508Z">
                                        </path>
                                        <path fill="currentColor"
                                              d="M10.3987 3.12495L7.00007 6.63381V0.4C7.00007 0.179086 6.82098 -1.93129e-08 6.60007 0L5.40007 1.04907e-07C5.17916 1.2422e-07 5.00007 0.179086 5.00007 0.4V6.7258L1.60124 3.21736C1.43936 3.05027 1.17102 3.05087 1.0099 3.21869L0.114321 4.15149C-0.0385342 4.3107 -0.0380459 4.5622 0.115426 4.72081L5.04183 9.81233C5.15789 9.93227 5.31769 10 5.48464 10H6.42653C6.5935 10 6.75331 9.93226 6.86937 9.81231L11.8846 4.62835C12.038 4.46974 12.0385 4.21826 11.8857 4.05905L10.9901 3.12626C10.829 2.95843 10.5606 2.95784 10.3987 3.12495Z">
                                        </path>
                                    </svg>
                                </el-button>
                            </el-tooltip>
                        </el-button-group>
                    </el-col>
                </el-row>

                <el-row :span="8" style="font-size:10pt; margin-bottom:10px; color:#EDEDED;">
                    {{language.objectDimensions}}
                </el-row>
                <el-row type="flex" justify="space-between" :span="2" :gutter="10"
                        style="border-bottom:1px solid #373842; padding-bottom: 10px; margin-bottom:10px">
                    <el-col>
                        <el-row type="flex" justify="space-between"
                                style="margin-bottom:10px; align-items:center;">
                            <el-col style="font-size:10pt; color:#EDEDED;">
                                {{language.x}}
                            </el-col>
                            <el-col>
                                <el-input-number v-model="objectDimensionsPerCm.left" :controls="false" :precision="2" :size="activeSelection.type !== 'InteractiveText'? 'small' : 'large'" @blur="changeObjectDimensions" @change="handleChangeLeft"></el-input-number>
                            </el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between"
                                style="margin-bottom:10px; align-items:center;">
                            <el-col style="font-size:10pt; color:#EDEDED;">
                                {{language.y}}
                            </el-col>
                            <el-col>
                                <el-input-number v-model="objectDimensionsPerCm.top" :controls="false" :precision="2" :size="activeSelection.type !== 'InteractiveText'? 'small' : 'large'" @blur="changeObjectDimensions" @change="handleChangeTop"></el-input-number>
                            </el-col>
                        </el-row>
                    </el-col>

                    <el-col v-if="activeSelection.type !== 'InteractiveText'">
                        <el-row type="flex" justify="space-between"
                                style="margin-bottom:10px; align-items:center;">
                            <el-col style="font-size:10pt; color:#EDEDED;">
                                {{language.h}}
                            </el-col>
                            <el-col>
                                <el-input-number v-model="objectDimensionsPerCm.height" :controls="false" :precision="2" size="small" @blur="changeObjectDimensions" @change="handleChangeHeight"></el-input-number>
                            </el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between"
                                style="margin-bottom:10px; align-items:center;">
                            <el-col style="font-size:10pt; color:#EDEDED;">
                                {{language.w}}
                            </el-col>
                            <el-col>
                                <el-input-number v-model="objectDimensionsPerCm.width" :controls="false" :precision="2" size="small" @blur="changeObjectDimensions" @change="handleChangeWidth"></el-input-number>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>

                <el-row type="flex"
                        style="margin-bottom:10px; border-bottom:1px solid #373842; align-items:center; padding-bottom:10px;">
                    <el-col :span="24" style="display:flex; justify-content:flex-end;">
                        <el-button-group>
                            <el-button v-on:click="groupSelection" style="width:auto;" plain size="supermini"
                                       v-if="activeSelection.type === 'activeSelection' || activeSelection.type === 'group'">
                                {{activeSelection.type === 'activeSelection' ? language.group : activeSelection.type === 'group' ? language.ungroup : ''}}
                            </el-button>
                            <el-tooltip class="item" effect="dark" :content="language.duplicate" placement="top">
                                <el-button size="supermini" plain icon="el-icon-copy-document"
                                           v-on:click="cloneSelection">
                                </el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" :content="language.delete" placement="top">
                                <el-button size="supermini" icon="el-icon-delete" plain v-on:click="deleteSelection(false)">
                                </el-button>
                            </el-tooltip>
                        </el-button-group>
                    </el-col>
                </el-row>
            </div>

            <!-- activeSelection edit -->
        </div>
        <!-- pages -->
        <div class="pages-menu" v-if="pages.length > 1">
            <el-button :plain="index !== activePage" v-for="(page, index) in pages" :key="index" :type="index === activePage ? 'primary' : ''" v-on:click="setPage(index)">
                {{page.name || index}}
            </el-button>
        </div>

        <!-- zoom -->
        <div class="zoom">
            <div style="height: 40px; color: #C0C4CC; width: 40vw; min-width: 260px;">
                <el-row type="flex" justify="space-between">
                    <el-col :span="2" style="display:flex; align-items:center; justify-content:center;">
                        <el-tooltip class="item" effect="dark" :content="language.centerPage" placement="top">
                            <el-button plain icon="el-icon-full-screen" circle size="supermini" v-on:click="zoomToFit">
                            </el-button>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="2" style="display:flex; align-items:center; justify-content:center;">
                        <el-tooltip class="item" effect="dark" :content="language.zoomOut" placement="top">
                            <el-button plain icon="el-icon-minus" circle size="supermini" v-on:click="zoomOut">
                            </el-button>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="14" style="display:flex; align-items:center; justify-content:center;">
                        <el-slider :value="zoom" v-on:input="sliderZoom" :min="2" :max="200" :show-tooltip="false"
                                   style="width:100%;">
                        </el-slider>
                    </el-col>
                    <el-col :span="2" style="display:flex; align-items:center; justify-content:center;">
                        <el-tooltip class="item" effect="dark" :content="language.zoomIn" placement="top">
                            <el-button plain icon="el-icon-plus" circle size="supermini" v-on:click="zoomIn">
                            </el-button>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="2"
                            style="display:flex; align-items:center; justify-content:center; font-size:11pt; user-select:none;">
                        {{zoom}}%
                    </el-col>
                    <el-col :span="2" style="display:flex; align-items:center; justify-content:center;">
                        <el-tooltip class="item" effect="dark" :content="language.gridLines" placement="top">
                            <el-button plain icon="el-icon-s-grid" circle size="supermini"
                                       v-on:click="grid = !grid; setGrid()">
                            </el-button>
                        </el-tooltip>
                    </el-col>

                    <el-col :span="2" class="d_flex_center">
                        <el-tooltip class="item" effect="dark" :content="language.helperLine" placement="top">
                            <el-button plain icon="el-icon-set-up" circle size="supermini"
                                       @click="setHelperLines">
                            </el-button>
                        </el-tooltip>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- white bar -->
        <div class="white-bar">

            <!-- logo -->
            <div class="horizontal-menu">
                <div class="editor-logo"><img draggable="false" :src="logo" /></div>
                <el-menu mode="horizontal">

                    <!--<el-menu-item @click="home">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M 18.855469 13.285156 L 18.855469 19.714844 C 18.855469 19.945312 18.773438 20.148438 18.601562 20.316406 C 18.433594 20.488281 18.230469 20.570312 18 20.570312 L 12.855469 20.570312 L 12.855469 15.429688 L 9.429688 15.429688 L 9.429688 20.570312 L 4.285156 20.570312 C 4.054688 20.570312 3.851562 20.488281 3.683594 20.316406 C 3.511719 20.148438 3.429688 19.945312 3.429688 19.714844 L 3.429688 13.285156 C 3.429688 13.277344 3.429688 13.261719 3.433594 13.246094 C 3.441406 13.226562 3.441406 13.214844 3.441406 13.207031 L 11.144531 6.855469 L 18.84375 13.207031 C 18.851562 13.222656 18.855469 13.25 18.855469 13.285156 Z M 21.84375 12.363281 L 21.011719 13.351562 C 20.941406 13.433594 20.847656 13.480469 20.730469 13.5 L 20.691406 13.5 C 20.574219 13.5 20.480469 13.46875 20.410156 13.40625 L 11.144531 5.679688 L 1.875 13.40625 C 1.769531 13.476562 1.660156 13.507812 1.554688 13.5 C 1.4375 13.480469 1.34375 13.433594 1.273438 13.351562 L 0.441406 12.363281 C 0.371094 12.273438 0.339844 12.167969 0.347656 12.046875 C 0.355469 11.925781 0.40625 11.832031 0.496094 11.757812 L 10.125 3.738281 C 10.410156 3.503906 10.75 3.386719 11.144531 3.386719 C 11.535156 3.386719 11.875 3.503906 12.160156 3.738281 L 15.429688 6.46875 L 15.429688 3.855469 C 15.429688 3.730469 15.46875 3.628906 15.550781 3.550781 C 15.628906 3.46875 15.730469 3.429688 15.855469 3.429688 L 18.429688 3.429688 C 18.554688 3.429688 18.65625 3.46875 18.738281 3.550781 C 18.816406 3.628906 18.855469 3.730469 18.855469 3.855469 L 18.855469 9.320312 L 21.789062 11.757812 C 21.878906 11.832031 21.929688 11.925781 21.9375 12.046875 C 21.945312 12.167969 21.914062 12.273438 21.84375 12.363281 Z M 21.84375 12.363281 " />
                        </svg>
                        <span slot="title">{{ language.menuHome }}</span>
                    </el-menu-item>-->

                    <el-menu-item @click="undo">
                        <!-- svg icon -->
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M 12.316406 7.894531 C 9.214844 7.894531 6.386719 9.050781 4.222656 10.945312 L 0 6.722656 L 0 17.277344 L 10.558594 17.277344 L 6.316406 13.039062 C 7.941406 11.671875 10.023438 10.828125 12.316406 10.828125 C 16.476562 10.828125 19.996094 13.53125 21.226562 17.277344 L 24 16.363281 C 22.386719 11.449219 17.769531 7.894531 12.316406 7.894531 Z M 12.316406 7.894531 " />
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.undo }}</span>
                    </el-menu-item>
                    <el-menu-item @click="redo">
                        <!-- svg icon -->
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M 19.769531 10.945312 C 17.613281 9.050781 14.785156 7.894531 11.683594 7.894531 C 6.230469 7.894531 1.613281 11.449219 0 16.363281 L 2.773438 17.277344 C 4.003906 13.53125 7.523438 10.828125 11.683594 10.828125 C 13.976562 10.828125 16.058594 11.671875 17.683594 13.039062 L 13.441406 17.277344 L 24 17.277344 L 24 6.722656 Z M 19.769531 10.945312 " />
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.redo }}</span>
                    </el-menu-item>
                    <el-menu-item @click="contactSupport">
                        <!-- svg icon -->
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="m12 1.3984a10.601 10.601 0 0 0-10.602 10.602 10.601 10.601 0 0 0 10.602 10.602 10.601 10.601 0 0 0 10.602-10.602 10.601 10.601 0 0 0-10.602-10.602zm-4.4043 4.1992c0.16019-0.0050163 0.36854 0.033239 0.5625 0.20312 0.38793 0.3371 2.0918 2.041 2.0918 2.041s0.60486 0.50263 0.1875 1.0645c-0.33174 0.44411-1.0983 1.266-1.1973 1.373l0.28516 0.54297c0.38525 0.63406 1.1192 1.7468 2.2188 2.6484 0.7384 0.60998 1.9902 1.28 1.9902 1.2773 0.18192-0.16587 0.93102-0.85886 1.3457-1.1719 0.55915-0.41736 1.0645 0.1875 1.0645 0.1875s1.7039 1.7039 2.041 2.0918c0.33977 0.38793 0.15039 0.83398 0.15039 0.83398-0.52705 0.81599-0.98495 1.6621-3.1895 1.7129-2.25 0.002675-4.5812-1.8626-6.2773-3.7246-1.6935-1.648-3.2605-3.7752-3.2578-5.8379 0.050832-2.2045 0.8969-2.6624 1.7129-3.1895 0 0 0.1113-0.047718 0.27148-0.052734z" />
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.contactSupport }}</span>
                    </el-menu-item>
                </el-menu>
                <!-- export -->
                <div class="export">
                    <el-button plain type="info" v-on:click="closeEditor">{{language.cancelBtn}}</el-button>
                    <el-button plain type="info btn-preview" v-on:click="previewEditor">{{language.previewBtn}}</el-button>
                    <el-button type="primary" v-on:click="exportDrawing">{{language.saveBtn}}</el-button>
                </div>
            </div>
        </div>
        <!-- container -->
        <div class="container">
            <div class="menu">
                <el-menu _background-color="#3f414c" _text-color="#73757C" text-color="#fff" active-text-color="#EDEDED" ref="menu">
                    <el-menu-item :class="{ active: tab === 'pages' }" :index="'pages'" class="custom" @click="navMenu('pages')" v-if="tabPagesVisible">
                        <!-- svg icon -->
                        <svg viewBox="0 0 24 24">
                            <path fill="currentColor" fill-rule="evenodd"
                                  d="M3 2C2.44772 2 2 2.44772 2 3V8C2 8.55228 2.44772 9 3 9H9C9.55228 9 10 8.55228 10 8V3C10 2.44772 9.55228 2 9 2H3ZM8 4H4V7H8V4Z">
                            </path>
                            <path fill="currentColor" fill-rule="evenodd"
                                  d="M3 11C2.44772 11 2 11.4477 2 12V21C2 21.5523 2.44772 22 3 22H9C9.55228 22 10 21.5523 10 21V12C10 11.4477 9.55228 11 9 11H3ZM8 13H4V20H8V13Z">
                            </path>
                            <path fill="currentColor" fill-rule="evenodd"
                                  d="M13 15C12.4477 15 12 15.4477 12 16V21C12 21.5523 12.4477 22 13 22H21C21.5523 22 22 21.5523 22 21V16C22 15.4477 21.5523 15 21 15H13ZM20 17H14V20H20V17Z">
                            </path>
                            <path fill="currentColor" fill-rule="evenodd"
                                  d="M13 2C12.4477 2 12 2.44771 12 3V12C12 12.5523 12.4477 13 13 13H21C21.5523 13 22 12.5523 22 12V3C22 2.44772 21.5523 2 21 2H13ZM20 4H14V11H20V4Z">
                            </path>
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.pages }}</span>
                    </el-menu-item>
                    <el-menu-item :class="{ active: tab === 'text' }" :index="'text'" class="custom" @click="navMenu('text')">
                        <!-- svg icon -->
                        <svg viewBox="0 0 24 24">
                            <path fill="currentColor" d="M16 8V10H13V16H11V10H8V8H16Z"></path>
                            <path fill="currentColor" fill-rule="evenodd"
                                  d="M0 1C0 0.447715 0.447715 0 1 0H5C5.55228 0 6 0.447715 6 1V2H18V1C18 0.447715 18.4477 0 19 0H23C23.5523 0 24 0.447715 24 1V5C24 5.55228 23.5523 6 23 6H22V18H23C23.5523 18 24 18.4477 24 19V23C24 23.5523 23.5523 24 23 24H19C18.4477 24 18 23.5523 18 23V22H6V23C6 23.5523 5.55228 24 5 24H1C0.447715 24 0 23.5523 0 23V19C0 18.4477 0.447715 18 1 18H2V6H1C0.447715 6 0 5.55228 0 5V1ZM20 20V22H22V20H20ZM18 20H6V19C6 18.4477 5.55228 18 5 18H4V6H5C5.55228 6 6 5.55228 6 5V4H18V5C18 5.55228 18.4477 6 19 6H20V18H19C18.4477 18 18 18.4477 18 19V20ZM2 20H4V22H2V20ZM2 4H4V2H2V4ZM20 4V2H22V4H20Z">
                            </path>
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.text }}</span>
                    </el-menu-item>
                    <el-menu-item :class="{ active: tab === 'images' }" :index="'images'" class="custom" @click="navMenu('images')">
                        <svg viewBox="0 0 492 492">
                            <path fill="currentColor" d="m245.59 0.082031c-7.212 0-13.967 2.7917-19.031 7.8477l-94.32 94.32c-5.064 5.064-7.8516 11.819-7.8516 19.027 0 7.204 2.7876 13.957 7.8516 19.025l16.115 16.119c5.072 5.064 11.821 7.8516 19.029 7.8516s13.78-2.7876 18.844-7.8516l21.34-21.52v191.74c0 14.832 12.068 26.904 26.904 26.904h23.16c14.836 0 26.807-12.076 26.807-26.908v-190.56l20.432 20.393c5.068 5.06 11.849 7.8516 19.057 7.8516 7.2 0 13.973-2.7916 19.037-7.8516l16.119-16.125c5.068-5.068 7.8594-11.819 7.8594-19.023-4e-3 -7.204-2.7836-13.961-7.8516-19.025l-94.348-94.359c-5.068-5.056-11.824-7.8477-19.152-7.8477zm-207.14 149.74c-21.196 0-38.443 17.244-38.443 38.436v265.1c0 21.196 17.247 38.561 38.443 38.561h414.9c21.196 0 38.652-17.365 38.652-38.561v-265.1c0-21.196-17.248-38.436-38.436-38.436h-34.621c-14.724 0-26.879 12.436-26.879 27.164v22.795c0 13.556 11.532 24.805 23.064 26.645v188.61h-338.25v-188.59c7.688-0.776 11.059-3.4261 15.291-7.6621 5.088-5.092 7.7676-11.846 7.7676-19.006v-22.799c0-14.728-12.172-27.164-26.9-27.164h-34.592z" />
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.images }}</span>
                    </el-menu-item>
                    <el-menu-item :class="{ active: tab === 'shapes' }" :index="'shapes'" class="custom" @click="navMenu('shapes')">
                        <!-- svg icon -->
                        <svg viewBox="0 0 24 24">
                            <path fill="currentColor" fill-rule="evenodd"
                                  d="M14.9291 7C14.4439 3.60771 11.5265 1 8 1C4.13401 1 1 4.13401 1 8C1 11.5265 3.60771 14.4439 7 14.9291V21C7 22.1046 7.89543 23 9 23H21C22.1046 23 23 22.1046 23 21V9C23 7.89543 22.1046 7 21 7H14.9291ZM9 14.9291V21H21V9H14.9291C14.4906 12.0657 12.0657 14.4906 9 14.9291ZM12.9468 7.96889C12.9468 10.718 10.7181 12.9467 7.96899 12.9467C5.21984 12.9467 2.99121 10.718 2.99121 7.96889C2.99121 5.21974 5.21984 2.99111 7.96899 2.99111C10.7181 2.99111 12.9468 5.21974 12.9468 7.96889Z">
                            </path>
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.shapes }}</span>
                    </el-menu-item>


                    <el-menu-item v-if="false" _v-if="cliparts.length > 0" :class="{ active: tab === 'cliparts' }" :index="'cliparts'" class="custom" @click="navMenu('cliparts')">
                        <!-- svg icon -->
                        <svg viewBox="0 0 24 24">
                            <path fill="currentColor" fill-rule="evenodd" d="m7.3086 0.67578c-0.84121 1e-8 -1.5137 0.69606-1.5137 1.5137v2.7617h-3.2109c-0.83589 0-1.5156 0.67744-1.5156 1.5137v15.346c0 0.83624 0.67974 1.5137 1.5156 1.5137h14.107c0.8359 0 1.5137-0.67777 1.5137-1.5137v-2.7617h3.2109c0.83588 0 1.5156-0.67744 1.5156-1.5137v-15.346c0-0.83623-0.67974-1.5137-1.5156-1.5137zm0.23242 1.7461h13.689v9.8164l-3.0254-2.9102v-1.082c1.448-0.098326 2.6328-1.2539 2.6328-2.7266 0-1.5367-1.2634-2.7734-2.7969-2.7734-1.3274 0-2.3593 0.97485-2.6348 2.2266h-7.8652zm10.461 2.0254c0.05641-0.00137 0.11617 0.00533 0.17578 0.013672l0.04102 0.00586c0.43247 0.069196 0.79064 0.42197 0.87891 0.86328 0.05448 0.33261-0.04088 0.61373-0.22461 0.82227-0.15898 0.18045-0.40768 0.27116-0.66797 0.31641v-0.00391c0-0.6451-0.47549-1.1052-1.0586-1.3027 0.15494-0.37976 0.43949-0.70472 0.85547-0.71484zm-15.209 2.2266h13.689v10.449c-0.77927-0.70032-1.4382-1.3023-2.1484-1.8711-0.87316-0.61532-2.0191-0.62563-2.8633 0.07617-0.51499 0.47519-1.0761 0.96341-1.5684 1.4414h-0.00195l-0.058594 0.05859c-0.14098 0.14097-0.31739 0.1993-0.50586 0.18359-0.18499-0.01542-0.365-0.1106-0.49805-0.25977l-1.3848-1.7441c-0.43527-0.53768-1.0823-0.87284-1.7988-0.89844-0.64359-0.02384-1.2346 0.26903-1.7031 0.70508h-0.089844l-1.0684 1.1602zm10.658 0.23438c-1.5366 0-2.7969 1.2603-2.7969 2.7969 0 1.5366 1.2603 2.7969 2.7969 2.7969 1.5366 0 2.7969-1.2603 2.7969-2.7969 0-1.5366-1.2603-2.7969-2.7969-2.7969zm0 1.7227c0.60758 0 1.0742 0.46664 1.0742 1.0742 0 0.6076-0.46624 1.0723-1.0742 1.0723-0.60799 0-1.0723-0.46428-1.0723-1.0723 0-0.60797 0.46467-1.0742 1.0723-1.0742zm4.7539 3.1074 3.002 2.8887v2.6992h-3.002zm-12.607 4.0938c0.20356 0 0.3515 0.07951 0.48633 0.24805l1.4414 1.7773c0.41494 0.51777 1.0479 0.84894 1.7168 0.90039 0.63503 0.04885 1.245-0.20486 1.7207-0.61328h0.05278l0.17383-0.16797 0.03125-0.03125h2e-3l1.332-1.2949c0.2729-0.25685 0.66655-0.25685 0.93945 0l2.9883 2.8809v2.0703h-13.69v-3.0723l2.2812-2.4727c0.14714-0.14426 0.34044-0.22461 0.52344-0.22461z" />
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.clipartsHeader }}</span>
                    </el-menu-item>




                    <div class="dropdown-menu-divider" />


                    <!-- cp_0 -->
                    <el-menu-item v-if="cp_0.length > 0" :class="{ active: tab === 'cp_0' }" :index="'cp_0'" class="custom cp0" @click="navMenu('cp_0')">
                        <!-- svg icon -->
                        <svg version="1.1" viewBox="0 0 24 24">
                            <path fill="currentColor" fill-rule="evenodd" d="m7.3086 0.67578c-0.84121 1e-8 -1.5137 0.69606-1.5137 1.5137v2.7617h-3.2109c-0.83589 0-1.5156 0.67744-1.5156 1.5137v15.346c0 0.83624 0.67974 1.5137 1.5156 1.5137h14.107c0.8359 0 1.5137-0.67777 1.5137-1.5137v-2.7617h3.2109c0.83588 0 1.5156-0.67744 1.5156-1.5137v-15.346c0-0.83623-0.67974-1.5137-1.5156-1.5137zm0.23242 1.7461h13.689v9.8164l-3.0254-2.9102v-1.082c1.448-0.098326 2.6328-1.2539 2.6328-2.7266 0-1.5367-1.2634-2.7734-2.7969-2.7734-1.3274 0-2.3593 0.97485-2.6348 2.2266h-7.8652zm10.461 2.0254c0.05641-0.00137 0.11617 0.00533 0.17578 0.013672l0.04102 0.00586c0.43247 0.069196 0.79064 0.42197 0.87891 0.86328 0.05448 0.33261-0.04088 0.61373-0.22461 0.82227-0.15898 0.18045-0.40768 0.27116-0.66797 0.31641v-0.00391c0-0.6451-0.47549-1.1052-1.0586-1.3027 0.15494-0.37976 0.43949-0.70472 0.85547-0.71484zm-15.209 2.2266h13.689v10.449c-0.77927-0.70032-1.4382-1.3023-2.1484-1.8711-0.87316-0.61532-2.0191-0.62563-2.8633 0.07617-0.51499 0.47519-1.0761 0.96341-1.5684 1.4414h-0.00195l-0.058594 0.05859c-0.14098 0.14097-0.31739 0.1993-0.50586 0.18359-0.18499-0.01542-0.365-0.1106-0.49805-0.25977l-1.3848-1.7441c-0.43527-0.53768-1.0823-0.87284-1.7988-0.89844-0.64359-0.02384-1.2346 0.26903-1.7031 0.70508h-0.089844l-1.0684 1.1602zm10.658 0.23438c-1.5366 0-2.7969 1.2603-2.7969 2.7969 0 1.5366 1.2603 2.7969 2.7969 2.7969 1.5366 0 2.7969-1.2603 2.7969-2.7969 0-1.5366-1.2603-2.7969-2.7969-2.7969zm0 1.7227c0.60758 0 1.0742 0.46664 1.0742 1.0742 0 0.6076-0.46624 1.0723-1.0742 1.0723-0.60799 0-1.0723-0.46428-1.0723-1.0723 0-0.60797 0.46467-1.0742 1.0723-1.0742zm4.7539 3.1074 3.002 2.8887v2.6992h-3.002zm-12.607 4.0938c0.20356 0 0.3515 0.07951 0.48633 0.24805l1.4414 1.7773c0.41494 0.51777 1.0479 0.84894 1.7168 0.90039 0.63503 0.04885 1.245-0.20486 1.7207-0.61328h0.05278l0.17383-0.16797 0.03125-0.03125h2e-3l1.332-1.2949c0.2729-0.25685 0.66655-0.25685 0.93945 0l2.9883 2.8809v2.0703h-13.69v-3.0723l2.2812-2.4727c0.14714-0.14426 0.34044-0.22461 0.52344-0.22461z" />
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.cp_0 }}</span>
                    </el-menu-item>
                    <!-- cp_0 -->
                    <el-menu-item v-if="cp_1.length > 0" :class="{ active: tab === 'cp_1' }" :index="'cp_1'" class="custom cp1" @click="navMenu('cp_1')">
                        <!-- svg icon -->
                        <svg version="1.1" viewBox="0 0 380 380">
                            <path fill="currentColor" d="m194.92 0c-107.66 0.043-194.92 87.331-194.92 195 0 107.7 87.305 195 195 195h0.20703c9.678-0.01 16.797-9.1724 14.473-18.566-2.201-8.902-3.3627-18.213-3.3457-27.799 0.038-21.992 6.3705-42.59 17.271-60.086l-30.113-30.111c-14.192-0.5-27.466-6.2526-37.562-16.35-5.773-5.773-14.08-17.463-19.543-52.162-2.748-17.452-3.4798-32.72-3.5098-33.361l-0.8164-17.541 17.541 0.81445c0.642 0.029 15.911 0.76177 33.363 3.5098 34.699 5.463 46.387 13.772 52.16 19.545 10.131 10.131 15.862 23.492 16.35 37.561l38.141 38.143c9.765-2.798 20.052-4.3296 30.67-4.3906 16.439-0.096 32.08 3.2702 46.24 9.4102 8.978 3.893 19.202-1.7015 20.812-11.354 1.77-10.614 2.6822-21.518 2.6602-32.639-0.204-107.2-87.879-194.67-195.08-194.62zm-37.77 42.994c9.5911 0.13774 18.386 6.4481 21.246 16.125 3.52 11.92-3.2812 24.43-15.201 27.949-2.13 0.63-4.2687 0.93164-6.3887 0.93164-9.71 0-18.671-6.3419-21.561-16.131-3.52-11.921 3.2792-24.43 15.199-27.949 2.235-0.66019 4.4918-0.95757 6.7051-0.92578zm107.95 14.197c3.9808 0.015325 8.0086 1.0874 11.652 3.3184 10.6 6.49 13.92 20.34 7.4297 30.939-4.25 6.931-11.639 10.75-19.209 10.75-4.01 0-8.0705-1.0784-11.73-3.3184-10.6-6.5-13.92-20.352-7.4297-30.941 4.2591-6.9562 11.687-10.777 19.287-10.748zm-191.44 56.391c3.2762 0.01429 6.6017 0.74734 9.7461 2.2774 11.17 5.441 15.809 18.911 10.369 30.08-3.9 8-11.91 12.65-20.24 12.65-3.31 0-6.6698-0.73125-9.8398-2.2812-11.17-5.439-15.819-18.91-10.369-30.08h-0.009766c3.9172-8.0284 11.971-12.683 20.344-12.646zm253.89 33.238c5.92 0 11.718 2.4098 15.908 6.5898 4.19 4.19 6.5918 9.9902 6.5918 15.91 0 5.93-2.4018 11.72-6.5918 15.91s-9.9882 6.5898-15.908 6.5898c-5.92 0-11.72-2.3988-15.91-6.5898-4.19-4.18-6.5898-9.9792-6.5898-15.91 0-5.92 2.3998-11.72 6.5898-15.91 4.19-4.18 9.9902-6.5898 15.91-6.5898zm-178.69 3.998s2.7578 59.326 18.385 74.953c8.931 8.931 21.032 12.756 32.684 11.469 8.726-0.962 17.196-4.7798 23.885-11.469s10.508-15.159 11.469-23.885c1.287-11.652-2.5378-23.753-11.469-32.684-15.627-15.627-74.953-18.385-74.953-18.385zm99.771 64.416c-2.74 8.182-7.3529 15.702-13.504 21.852-6.148 6.15-13.669 10.763-21.852 13.504l108.66 108.66c9.666 9.666 25.336 9.666 35.002 0l0.35547-0.35352c9.666-9.666 9.666-25.337 0-35.002l-108.67-108.66zm-178.57 7.4121c8.7656 0.16219 17.002 5.4756 20.475 14.123 4.63 11.531-0.95828 24.63-12.488 29.26-2.75 1.11-5.5909 1.6289-8.3809 1.6289-8.92 0-17.361-5.3401-20.891-14.119-4.63-11.53 0.96-24.63 12.5-29.27 2.8825-1.1575 5.8633-1.6771 8.7852-1.623zm77.705 76.334c5.93 0 11.72 2.3998 15.91 6.5898 4.19 4.181 6.5898 9.9802 6.5898 15.91 0 5.92-2.3998 11.72-6.5898 15.91-4.19 4.18-9.9802 6.5801-15.91 6.5801-5.92 0-11.72-2.4001-15.91-6.5801-4.19-4.19-6.5898-9.9902-6.5898-15.91 0-5.93 2.3998-11.729 6.5898-15.91 4.19-4.19 9.9902-6.5898 15.91-6.5898z" />
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.cp_1 }}</span>
                    </el-menu-item>
                    <!-- cp_0 -->
                    <el-menu-item v-if="cp_3.length > 0" :class="{ active: tab === 'cp_3' }" :index="'cp_3'" class="custom cp3" @click="navMenu('cp_3')">
                        <!-- svg icon -->
                        <svg version="1.1" viewBox="0 0 24 24">
                            <path fill="currentColor" fill-rule="evenodd" d="m7.3086 0.67578c-0.84121 1e-8 -1.5137 0.69606-1.5137 1.5137v2.7617h-3.2109c-0.83589 0-1.5156 0.67744-1.5156 1.5137v15.346c0 0.83624 0.67974 1.5137 1.5156 1.5137h14.107c0.8359 0 1.5137-0.67777 1.5137-1.5137v-2.7617h3.2109c0.83588 0 1.5156-0.67744 1.5156-1.5137v-15.346c0-0.83623-0.67974-1.5137-1.5156-1.5137zm0.23242 1.7461h13.689v9.8164l-3.0254-2.9102v-1.082c1.448-0.098326 2.6328-1.2539 2.6328-2.7266 0-1.5367-1.2634-2.7734-2.7969-2.7734-1.3274 0-2.3593 0.97485-2.6348 2.2266h-7.8652zm10.461 2.0254c0.05641-0.00137 0.11617 0.00533 0.17578 0.013672l0.04102 0.00586c0.43247 0.069196 0.79064 0.42197 0.87891 0.86328 0.05448 0.33261-0.04088 0.61373-0.22461 0.82227-0.15898 0.18045-0.40768 0.27116-0.66797 0.31641v-0.00391c0-0.6451-0.47549-1.1052-1.0586-1.3027 0.15494-0.37976 0.43949-0.70472 0.85547-0.71484zm-15.209 2.2266h13.689v10.449c-0.77927-0.70032-1.4382-1.3023-2.1484-1.8711-0.87316-0.61532-2.0191-0.62563-2.8633 0.07617-0.51499 0.47519-1.0761 0.96341-1.5684 1.4414h-0.00195l-0.058594 0.05859c-0.14098 0.14097-0.31739 0.1993-0.50586 0.18359-0.18499-0.01542-0.365-0.1106-0.49805-0.25977l-1.3848-1.7441c-0.43527-0.53768-1.0823-0.87284-1.7988-0.89844-0.64359-0.02384-1.2346 0.26903-1.7031 0.70508h-0.089844l-1.0684 1.1602zm10.658 0.23438c-1.5366 0-2.7969 1.2603-2.7969 2.7969 0 1.5366 1.2603 2.7969 2.7969 2.7969 1.5366 0 2.7969-1.2603 2.7969-2.7969 0-1.5366-1.2603-2.7969-2.7969-2.7969zm0 1.7227c0.60758 0 1.0742 0.46664 1.0742 1.0742 0 0.6076-0.46624 1.0723-1.0742 1.0723-0.60799 0-1.0723-0.46428-1.0723-1.0723 0-0.60797 0.46467-1.0742 1.0723-1.0742zm4.7539 3.1074 3.002 2.8887v2.6992h-3.002zm-12.607 4.0938c0.20356 0 0.3515 0.07951 0.48633 0.24805l1.4414 1.7773c0.41494 0.51777 1.0479 0.84894 1.7168 0.90039 0.63503 0.04885 1.245-0.20486 1.7207-0.61328h0.05278l0.17383-0.16797 0.03125-0.03125h2e-3l1.332-1.2949c0.2729-0.25685 0.66655-0.25685 0.93945 0l2.9883 2.8809v2.0703h-13.69v-3.0723l2.2812-2.4727c0.14714-0.14426 0.34044-0.22461 0.52344-0.22461z" />
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.cp_3 }}</span>
                    </el-menu-item>
                    <el-menu-item v-if="cp_2.length > 0" :class="{ active: tab === 'cp_2' }" :index="'cp_2'" class="custom cp2" @click="navMenu('cp_2')">
                        <!-- svg icon -->
                        <svg version="1.1" viewBox="0 0 376 376">
                            <!--<path fill="currentColor" fill-rule="evenodd" d="m7.3086 0.67578c-0.84121 1e-8 -1.5137 0.69606-1.5137 1.5137v2.7617h-3.2109c-0.83589 0-1.5156 0.67744-1.5156 1.5137v15.346c0 0.83624 0.67974 1.5137 1.5156 1.5137h14.107c0.8359 0 1.5137-0.67777 1.5137-1.5137v-2.7617h3.2109c0.83588 0 1.5156-0.67744 1.5156-1.5137v-15.346c0-0.83623-0.67974-1.5137-1.5156-1.5137zm0.23242 1.7461h13.689v9.8164l-3.0254-2.9102v-1.082c1.448-0.098326 2.6328-1.2539 2.6328-2.7266 0-1.5367-1.2634-2.7734-2.7969-2.7734-1.3274 0-2.3593 0.97485-2.6348 2.2266h-7.8652zm10.461 2.0254c0.05641-0.00137 0.11617 0.00533 0.17578 0.013672l0.04102 0.00586c0.43247 0.069196 0.79064 0.42197 0.87891 0.86328 0.05448 0.33261-0.04088 0.61373-0.22461 0.82227-0.15898 0.18045-0.40768 0.27116-0.66797 0.31641v-0.00391c0-0.6451-0.47549-1.1052-1.0586-1.3027 0.15494-0.37976 0.43949-0.70472 0.85547-0.71484zm-15.209 2.2266h13.689v10.449c-0.77927-0.70032-1.4382-1.3023-2.1484-1.8711-0.87316-0.61532-2.0191-0.62563-2.8633 0.07617-0.51499 0.47519-1.0761 0.96341-1.5684 1.4414h-0.00195l-0.058594 0.05859c-0.14098 0.14097-0.31739 0.1993-0.50586 0.18359-0.18499-0.01542-0.365-0.1106-0.49805-0.25977l-1.3848-1.7441c-0.43527-0.53768-1.0823-0.87284-1.7988-0.89844-0.64359-0.02384-1.2346 0.26903-1.7031 0.70508h-0.089844l-1.0684 1.1602zm10.658 0.23438c-1.5366 0-2.7969 1.2603-2.7969 2.7969 0 1.5366 1.2603 2.7969 2.7969 2.7969 1.5366 0 2.7969-1.2603 2.7969-2.7969 0-1.5366-1.2603-2.7969-2.7969-2.7969zm0 1.7227c0.60758 0 1.0742 0.46664 1.0742 1.0742 0 0.6076-0.46624 1.0723-1.0742 1.0723-0.60799 0-1.0723-0.46428-1.0723-1.0723 0-0.60797 0.46467-1.0742 1.0723-1.0742zm4.7539 3.1074 3.002 2.8887v2.6992h-3.002zm-12.607 4.0938c0.20356 0 0.3515 0.07951 0.48633 0.24805l1.4414 1.7773c0.41494 0.51777 1.0479 0.84894 1.7168 0.90039 0.63503 0.04885 1.245-0.20486 1.7207-0.61328h0.05278l0.17383-0.16797 0.03125-0.03125h2e-3l1.332-1.2949c0.2729-0.25685 0.66655-0.25685 0.93945 0l2.9883 2.8809v2.0703h-13.69v-3.0723l2.2812-2.4727c0.14714-0.14426 0.34044-0.22461 0.52344-0.22461z" />-->
                            <path fill="currentColor" d="m93.637 0c-51.715 0-93.637 41.923-93.637 93.639 0 48.722 38.79 93.207 84.771 93.207l102.03-0.03906 0.04492-102.03c1e-3 -46.16-44.484-84.773-93.209-84.773zm183.14 46.668c-36.553 0-69.928 29.103-69.928 63.6l0.0293 76.545 76.551 0.0332c34.631 0 63.598-33.373 63.598-69.928 0-38.799-31.451-70.25-70.25-70.25zm-182.53 160.18c-41.877 0-76.908 40.358-76.908 84.562 0 46.918 38.033 84.949 84.951 84.949 44.202 0 84.561-35.192 84.561-76.908l-0.03515-92.562-92.568-0.04102zm205.21 0-92.57 0.04102-0.03516 92.562c0 41.716 40.359 76.908 84.561 76.908 46.918 0 84.951-38.031 84.951-84.949-1e-3 -44.205-35.029-84.562-76.906-84.562z" />
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.cp_2 }}</span>
                    </el-menu-item>
                    <!-- cp_0 -->
                    <el-menu-item v-if="cp_4.length > 0" :class="{ active: tab === 'cp_4' }" :index="'cp_4'" class="custom cp4" @click="navMenu('cp_4')">
                        <!-- svg icon -->
                        <svg version="1.1" viewBox="0 0 510 510">
                            <path fill="currentColor" d="m193.71 0-0.80469 37.52h5.2969c1.615-9.9 3.9278-12.238 6.9648-17.068 3.031-4.835 6.2705-7.7304 9.7285-8.6934 3.446-0.96 10.196-1.4414 20.254-1.4414h30.686v105.14c0 13.045-0.36684 21.356-1.0898 24.924-0.733 3.57-2.387 6.1909-4.959 7.8789-2.565 1.691-9.7028 2.5332-16.383 2.5332h-8.0566v5.2949h26.604c-13.761 2.208-25.71 7.363-35.814 15.543-13.847 11.196-20.76 26.048-20.76 44.562 0 18.98 6.8199 34.215 20.461 45.709 12.831 10.823 29.1 16.482 48.703 17.121v122.13l-102.36-226.97c-9.217-20.974-8.7949-34.304-8.7949-39.992 0-8.818 3.6839-14.803 11.045-17.936 7.363-3.133 16.727-4.707 38.182-4.707v-13.527h-171.43v13.527c18.78 0.394 32.375 3.8212 40.791 10.281 8.422 6.451 16.445 19.074 24.07 37.863 3.667 9.283 6.6579 16.698 9.0039 22.312-11.159 0.604-22.393 3.369-33.518 8.293-17.036 7.554-31.125 18.624-41.887 32.93-10.823 14.404-16.668 31.877-17.352 51.93-0.685 19.83 3.1264 39.257 11.318 57.742 12.523 28.277 31.552 47.484 56.553 57.094 11.062 4.245 22.508 6.4004 34.029 6.4004 14.491 0 29.506-3.4023 44.652-10.111 10.777-4.776 20.065-10.884 27.854-18.271l66.336 151.02h10.326l93.963-233.27 17.863 7.5801c4.544 1.607 7.5898 3.5025 9.0508 5.6035 1.139 1.631 3.4082 6.1278 7.7442 18.299 3.535 9.898 6.763 20.235 9.625 30.729 9.127 33.664 14.002 54.884 20.926 64.646l0.45703 0.65039 50.303 18.971-1.4199-11.105-2.2656-0.89454c-10.392-4.087-17.461-9.1303-23.145-17.447-5.822-8.525-7.5729-22.511-14.67-49.885-6.364-24.547-8.2416-32.607-14.307-49.762 15.912 2.697 29.471 1.5225 40.508-3.4355 12.706-5.702 21.455-15.109 26.041-27.969 3.94-11.06 3.6794-22.021-0.76563-32.566-4.356-10.396-11.813-19.488-22.133-27.02-10.146-7.401-24.414-14.411-42.428-20.832-5.488-1.962-12.085-4.1758-19.709-6.6348l9.7637-22.861c6.854-16.265 14.985-28.617 24.398-37.049 9.399-8.433 20.278-12.842 32.623-13.236v-13.525h-121.44v13.527c31.853 0.785 39.664 12.171 39.664 34.707 0 11.174-9.6555 34.825-25.145 71.684l-77.555 186.49v-126.08c15.918-1.899 29.22-7.3435 39.832-16.438 13.404-11.494 20.115-26.523 20.115-45.092 0-19.157-7.0039-34.279-21.006-45.363-10.207-8.076-22.269-13.174-36.135-15.365h34.258v-5.293h-7.5996c-6.98 0-14.253-0.92063-16.793-2.7656-2.525-1.838-4.0872-4.6776-4.6602-8.5156-0.582-3.844-0.85742-11.859-0.85742-24.061v-105.14h20.062c8.511 0 27.119 0.52174 30.648 1.5527 3.529 1.042 6.8402 3.8442 9.9062 8.4062 3.068 4.566 5.4791 6.9582 7.2461 17.24h4.9531l-0.8125-37.52h-176.76zm82.338 159.8c9.41-0.22523 17.584 2.6017 24.523 8.4727 9.259 7.828 15.837 20.583 19.742 38.238 4.005 18.172 3.3842 32.641-1.8828 43.416-5.262 10.771-14.17 17.544-26.717 20.314-14.305 3.166-26.044 0.95037-35.219-6.6406-9.174-7.587-15.774-20.518-19.809-38.795-3.973-18-3.4013-32.384 1.7207-43.158 5.122-10.769 14.388-17.638 27.818-20.604 3.4112-0.75325 6.6856-1.1691 9.8223-1.2441zm-156.7 36.418c0.63228-0.0065 1.2666-0.00477 1.9004 0.00586l68.965 156.99c-6.914 7.146-14.454 12.562-22.471 16.119-8.093 3.591-16.309 5.3945-24.447 5.3945h-0.00586c-9.187 0-18.59-2.309-27.959-6.873-17.84-8.689-32.824-26.488-44.531-52.896-12.41-28.011-16.58-52.164-12.387-71.795 4.153-19.444 14.97-32.792 33.082-40.811 9.06-4.0162 18.369-6.0411 27.854-6.1387zm293.59 3.1914c3.595 0.999 6.779 1.9889 9.502 2.9629 21.248 7.57 33.785 16.215 37.254 25.693 3.535 9.636 3.0655 20.89-1.3945 33.418-2.577 7.229-5.6912 13.023-9.2402 17.236-3.502 4.148-7.3684 7.1801-11.482 8.9961-4.113 1.807-9.0387 2.595-14.637 2.332-5.799-0.268-12.412-1.5102-19.668-3.6992-6.638-1.997-13.067-4.0057-19.172-5.9707l28.838-80.969zm-129.79 0.08007c-6.126 0-11.102 6.6619-11.102 14.881s4.9756 14.885 11.102 14.885c6.134 0 11.109-6.6658 11.109-14.885s-4.9744-14.881-11.109-14.881z" />
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.cp_4 }}</span>
                    </el-menu-item>
                    <!-- cp_0 -->
                    <el-menu-item v-if="cp_5.length > 0" :class="{ active: tab === 'cp_5' }" :index="'cp_5'" class="custom cp5" @click="navMenu('cp_5')">
                        <!-- svg icon -->
                        <svg version="1.1" viewBox="0 0 24 24">
                            <path fill="currentColor" d="m4.5608 1.9463c-0.45445-0.0064453-0.86551 0.27031-1.0296 0.69417l-2.7342 7.0648c-0.21669 0.55974 0.060076 1.1886 0.61987 1.4053 0.55979 0.21662 1.1886-0.06012 1.4053-0.61987l0.23776-0.61138h2.7597l0.20804 0.58166c0.20074 0.56573 0.8205 0.86308 1.3862 0.66233 0.56571-0.20075 0.86306-0.8226 0.66233-1.3883l-2.5071-7.0648c-0.15199-0.42833-0.55389-0.71744-1.0083-0.72389zm5.4005 0c-0.60028 0-1.0869 0.48662-1.0869 1.0869v7.0648c0 0.60029 0.48662 1.0869 1.0869 1.0869h2.5814c0.32433 0 1.0451-0.04271 1.7237-0.40758 0.35509-0.19086 0.71926-0.47985 0.98924-0.9107 0.2727-0.43486 0.41183-0.95264 0.41183-1.5348 0-0.60074-0.13135-1.1357-0.40546-1.5858-0.11619-0.19088-0.25029-0.35404-0.39485-0.4925 0.21292-0.39628 0.33753-0.88037 0.33753-1.4541 0-0.57974-0.11033-1.0966-0.34815-1.5369-0.24172-0.44767-0.58278-0.75647-0.94254-0.9574-0.64659-0.36119-1.3393-0.35937-1.5773-0.35876h-2.3606zm9.782 0c-0.87854 0-1.5934 0.30147-2.1356 0.78333-0.51964 0.46192-0.83066 1.0438-1.0211 1.5518-0.19227 0.51248-0.28426 1.011-0.32904 1.3692-0.02272 0.18192-0.03436 0.33493-0.04034 0.4458-0.0029 0.055584-0.0057 0.10024-0.0064 0.13374-0.01717 0.90026 0.04827 1.8292 0.37999 2.6748 0.20368 0.51901 0.53023 1.0505 1.0487 1.4775 0.52464 0.43193 1.1859 0.70748 1.9827 0.79606 0.64214 0.0713 2.6443 0.03008 3.5558-1.9827 0.24759-0.54682 0.0055-1.1895-0.54132-1.4372-0.54682-0.24763-1.1896-0.00549-1.4372 0.54132-0.16978 0.37488-0.41533 0.54116-0.65597 0.63048-0.27248 0.10112-0.5504 0.10136-0.67931 0.087036-0.42591-0.047323-0.6817-0.17767-0.84484-0.31206-0.16934-0.13939-0.30128-0.33425-0.40334-0.59439-0.21923-0.55858-0.23139-1.2369-0.23139-1.8129v-0.012737c4.35e-4 -0.01426 0.0024-0.040736 0.0042-0.074299 0.0036-0.067463 0.01-0.16708 0.02548-0.29083 0.03174-0.25316 0.09244-0.57191 0.20592-0.87461 0.11521-0.3072 0.26279-0.54045 0.43094-0.68992 0.14576-0.12951 0.34794-0.23564 0.69205-0.23564 0.4428 0 0.65084 0.017162 0.82366 0.1019 0.11554 0.056616 0.36159 0.21718 0.59864 0.87461 0.20358 0.5647 0.82783 0.85742 1.3926 0.65383 0.56468-0.20359 0.85755-0.82576 0.65387-1.3905-0.37422-1.0381-0.93857-1.7237-1.6877-2.091-0.66246-0.32486-1.3435-0.32335-1.7322-0.32267-0.01717 3.26e-5 -0.03284 0-0.04882 0zm-8.6951 2.1738h1.2631c0.2414 0 0.424 0.016066 0.54345 0.082791 0.03554 0.019836 0.06264 0.042198 0.08916 0.091282 0.03043 0.056399 0.08704 0.20187 0.08704 0.50524 0 0.24836-0.04958 0.37297-0.08067 0.42881-0.03043 0.054899-0.07113 0.096238-0.12949 0.13162-0.14575 0.088364-0.36018 0.11794-0.50311 0.11888h-1.2695zm-6.549 2.0379 0.54982 1.5475h-1.1485zm6.549 1.4945h1.2631c0.0038 0 0.0087 2.17e-5 0.01274 0h0.21865c0.27248 0 0.53858 0.014411 0.72813 0.10826 0.07054 0.034922 0.10657 0.070104 0.13374 0.11463 0.02837 0.046693 0.08916 0.17405 0.08916 0.45641 0 0.22524-0.05078 0.33233-0.08067 0.37999-0.0325 0.051747-0.08321 0.1019-0.17407 0.15072-0.21281 0.11445-0.51108 0.1486-0.69629 0.1486h-1.4945zm0.52859 5.1627c-1.7754 0-2.9741 1.5313-2.9741 3.0144 0 0.60029 0.48662 1.0869 1.0869 1.0869 0.60029 0 1.0869-0.4866 1.0869-1.0869 0-0.44356 0.38033-0.84064 0.80031-0.84064 0.36139 0 0.62648 0.16914 0.74299 0.34814 0.0838 0.1288 0.1852 0.4049-0.10826 0.90433-0.13803 0.23509-0.35443 0.4579-0.67506 0.71115-0.15956 0.12597-0.33174 0.25028-0.52434 0.38636l-0.07855 0.05519c-0.16532 0.11652-0.34755 0.24434-0.52222 0.37574-0.82874 0.62366-1.8087 1.5481-1.8087 3.197 0 0.60029 0.48662 1.0869 1.0869 1.0869h3.7511c0.60029 0 1.0869-0.4866 1.0869-1.0869s-0.4866-1.0869-1.0869-1.0869h-2.1674c0.12336-0.11923 0.27081-0.242 0.4458-0.37362 0.14575-0.10978 0.29605-0.21558 0.46278-0.33329l0.08492-0.05944c0.19434-0.13738 0.40874-0.2893 0.61774-0.45429 0.41628-0.32878 0.86785-0.74826 1.2015-1.3162 0.64974-1.1061 0.65038-2.2757 0.05519-3.1906-0.56236-0.86462-1.5537-1.3374-2.5644-1.3374zm7.6231 0c-0.89408 0-1.5959 0.28872-2.1037 0.73662-0.48714 0.42965-0.73223 0.94844-0.84277 1.3353-0.16477 0.57725 0.16798 1.1789 0.74512 1.3438 0.57725 0.16477 1.1789-0.16798 1.3438-0.74512 0.02402-0.08413 0.08356-0.20879 0.19106-0.30357 0.08695-0.07674 0.26953-0.19318 0.66657-0.19318 0.6805 0 0.81517 0.42439 0.81517 0.51797 0 0.23749-0.05149 0.43249-0.14648 0.55194-0.05706 0.07195-0.2596 0.28871-0.985 0.28871-0.60029 0-1.0869 0.4866-1.0869 1.0869s0.4866 1.0869 1.0869 1.0869c0.28433 0 0.64695 0.0384 0.90008 0.15709 0.11271 0.05282 0.1599 0.1027 0.18044 0.13162 0.01315 0.01837 0.05094 0.07395 0.05094 0.22927 0 0.46595-0.14087 0.61833-0.20804 0.67506-0.1001 0.08445-0.29617 0.16558-0.60713 0.16558-0.36607 0-0.53072-0.06415-0.60713-0.11251-0.05565-0.03522-0.16346-0.12132-0.26323-0.42457-0.1876-0.57018-0.80117-0.87964-1.3714-0.69204-0.57018 0.1876-0.87964 0.80106-0.69205 1.3714 0.21727 0.66007 0.58498 1.2153 1.1633 1.5815 0.55758 0.35302 1.1855 0.45004 1.7704 0.45004 0.64007 0 1.395-0.15961 2.0082-0.67718 0.64605-0.5454 0.98075-1.3582 0.98075-2.3372 0-0.56725-0.15637-1.0721-0.45429-1.4902-0.04359-0.06119-0.08858-0.11929-0.13586-0.17407 0.50464-0.65844 0.59015-1.4078 0.59015-1.8681 0-1.3195-1.1334-2.6918-2.989-2.6918zm-13.455 0.0042c-0.54108-0.05358-1.0485 0.30705-1.1676 0.85126-0.11923 0.54508-0.68243 1.3713-1.469 1.8957-0.49946 0.33292-0.63442 1.0078-0.30144 1.5072 0.33297 0.49943 1.0078 0.63436 1.5072 0.30144 0.080061-0.05348 0.15947-0.10956 0.23776-0.1677v3.7596c0 0.60029 0.48661 1.0869 1.0869 1.0869 0.60027 0 1.0869-0.4866 1.0869-1.0869v-7.0648c0-0.56486-0.42981-1.0297-0.98075-1.0826z" />
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.cp_5 }}</span>
                    </el-menu-item>
                    <!-- cp_0 -->







                    <el-menu-item v-if="illustrations.length > 0" :class="{ active: tab === 'illustrations' }" :index="'illustrations'" class="custom" @click="navMenu('illustrations')">
                        <!-- svg icon -->
                        <svg viewBox="0 0 24 24">
                            <path fill="currentColor" fill-rule="evenodd" d="m7.3086 0.67578c-0.84121 1e-8 -1.5137 0.69606-1.5137 1.5137v2.7617h-3.2109c-0.83589 0-1.5156 0.67744-1.5156 1.5137v15.346c0 0.83624 0.67974 1.5137 1.5156 1.5137h14.107c0.8359 0 1.5137-0.67777 1.5137-1.5137v-2.7617h3.2109c0.83588 0 1.5156-0.67744 1.5156-1.5137v-15.346c0-0.83623-0.67974-1.5137-1.5156-1.5137zm0.23242 1.7461h13.689v9.8164l-3.0254-2.9102v-1.082c1.448-0.098326 2.6328-1.2539 2.6328-2.7266 0-1.5367-1.2634-2.7734-2.7969-2.7734-1.3274 0-2.3593 0.97485-2.6348 2.2266h-7.8652zm10.461 2.0254c0.05641-0.00137 0.11617 0.00533 0.17578 0.013672l0.04102 0.00586c0.43247 0.069196 0.79064 0.42197 0.87891 0.86328 0.05448 0.33261-0.04088 0.61373-0.22461 0.82227-0.15898 0.18045-0.40768 0.27116-0.66797 0.31641v-0.00391c0-0.6451-0.47549-1.1052-1.0586-1.3027 0.15494-0.37976 0.43949-0.70472 0.85547-0.71484zm-15.209 2.2266h13.689v10.449c-0.77927-0.70032-1.4382-1.3023-2.1484-1.8711-0.87316-0.61532-2.0191-0.62563-2.8633 0.07617-0.51499 0.47519-1.0761 0.96341-1.5684 1.4414h-0.00195l-0.058594 0.05859c-0.14098 0.14097-0.31739 0.1993-0.50586 0.18359-0.18499-0.01542-0.365-0.1106-0.49805-0.25977l-1.3848-1.7441c-0.43527-0.53768-1.0823-0.87284-1.7988-0.89844-0.64359-0.02384-1.2346 0.26903-1.7031 0.70508h-0.089844l-1.0684 1.1602zm10.658 0.23438c-1.5366 0-2.7969 1.2603-2.7969 2.7969 0 1.5366 1.2603 2.7969 2.7969 2.7969 1.5366 0 2.7969-1.2603 2.7969-2.7969 0-1.5366-1.2603-2.7969-2.7969-2.7969zm0 1.7227c0.60758 0 1.0742 0.46664 1.0742 1.0742 0 0.6076-0.46624 1.0723-1.0742 1.0723-0.60799 0-1.0723-0.46428-1.0723-1.0723 0-0.60797 0.46467-1.0742 1.0723-1.0742zm4.7539 3.1074 3.002 2.8887v2.6992h-3.002zm-12.607 4.0938c0.20356 0 0.3515 0.07951 0.48633 0.24805l1.4414 1.7773c0.41494 0.51777 1.0479 0.84894 1.7168 0.90039 0.63503 0.04885 1.245-0.20486 1.7207-0.61328h0.05278l0.17383-0.16797 0.03125-0.03125h2e-3l1.332-1.2949c0.2729-0.25685 0.66655-0.25685 0.93945 0l2.9883 2.8809v2.0703h-13.69v-3.0723l2.2812-2.4727c0.14714-0.14426 0.34044-0.22461 0.52344-0.22461z" />
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.illustrations }}</span>
                    </el-menu-item>
                    <el-menu-item v-if="fotos.length > 0" :class="{ active: tab === 'fotos' }" :index="'fotos'" class="custom" @click="navMenu('fotos')">
                        <!-- svg icon -->
                        <svg version="1.1" viewBox="0 0 24 24">
                            <path fill="currentColor" fill-rule="evenodd" d="m9.0039 3.2617c-0.63923 0-1.2246 0.25389-1.6484 0.67773-0.32499 0.32499-0.54786 0.74281-0.63477 1.2012h-2.8711c-0.78014 0-1.488 0.31365-1.9922 0.83984-0.50115 0.50319-0.83203 1.2109-0.83203 1.9844v9.9492c0 0.78019 0.31359 1.488 0.83984 1.9922 0.50318 0.5011 1.211 0.83203 1.9844 0.83203h16.301c0.78051 0 1.4899-0.31516 1.9941-0.8418 0.50077-0.50314 0.83008-1.2093 0.83008-1.9824v-9.9492c0-0.77765-0.31278-1.4844-0.83594-1.9883-0.50397-0.52421-1.2098-0.83594-1.9883-0.83594h-2.8906c-0.08455-0.46138-0.30324-0.88743-0.64062-1.207-0.42337-0.42061-1.0016-0.67188-1.623-0.67188zm0.019532 1.9746h5.9727c0.10644 0 0.1831 0.036615 0.22852 0.082031 0.04542 0.045416 0.08399 0.12207 0.08399 0.22852v0.58008c0 0.54891 0.45695 1.0059 1.0059 1.0059h3.8555c0.23841 0 0.43274 0.087038 0.58984 0.24414 0.1571 0.1571 0.24219 0.34948 0.24219 0.58789v9.4805h-0.01953v0.46875c0 0.23841-0.08704 0.43079-0.24414 0.58789-0.1571 0.1571-0.34948 0.24219-0.58789 0.24219h-16.301c-0.23841 0-0.43079-0.08508-0.58789-0.24219-0.1571-0.1571-0.24414-0.34948-0.24414-0.58789v-9.9492c0-0.23841 0.087036-0.43079 0.24414-0.58789 0.1571-0.1571 0.34948-0.24414 0.58789-0.24414h3.8555c0.5489 0 1.0059-0.45695 1.0059-1.0059v-0.58008c0-0.10644 0.038574-0.1831 0.083984-0.22852 0.04542-0.045416 0.12207-0.082031 0.22852-0.082031zm10.088 2.3008c-0.79318 0-1.4453 0.65408-1.4453 1.4473s0.65213 1.4453 1.4453 1.4453c0.79318 0 1.4473-0.65213 1.4473-1.4453s-0.65408-1.4473-1.4473-1.4473zm-7.1113 0.019531c-1.4867 0-2.8425 0.61208-3.8066 1.5762-0.98218 0.98218-1.5742 2.3245-1.5742 3.8066 0 1.4867 0.61013 2.8425 1.5742 3.8066 0.98218 0.98218 2.3245 1.5742 3.8066 1.5742 1.4867 0 2.8425-0.61013 3.8066-1.5742 0.98218-0.98218 1.5742-2.3245 1.5742-3.8066 0-1.4867-0.61013-2.8425-1.5742-3.8066s-2.3199-1.5762-3.8066-1.5762zm0 2.0332c0.92834 0 1.7706 0.38693 2.3887 0.98633 0.61262 0.61396 0.97852 1.4488 0.97852 2.3828v0.0039l2e-3 0.0039c0.01741 0.92283-0.3647 1.7579-0.98047 2.375-0.61808 0.59943-1.4603 0.98438-2.3887 0.98438-0.92834 0-1.7706-0.38498-2.3887-0.98438-0.61262-0.61396-0.97852-1.4488-0.97852-2.3828 0-0.92834 0.38498-1.7706 0.98438-2.3887 0.61391-0.6126 1.4488-0.98046 2.3828-0.98046z" />
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.fotos }}</span>
                    </el-menu-item>

                    <el-menu-item v-if="backgrounds.length > 0 && tabBackgroundsVisible" :class="{ active: tab === 'backgrounds' }" :index="'backgrounds'" class="custom" @click="navMenu('backgrounds')">
                        <!-- svg icon -->
                        <svg version="1.1" viewBox="0 0 24 24">
                            <path fill="currentColor" fill-rule="evenodd" d="m1.9707 1.0156-0.97656 0.97656v2.8438l3.8203-3.8203h-2.8438zm5.6445 0-6.6211 6.6211v2.8418l9.4648-9.4629h-2.8437zm5.6445 0-12.266 12.264v2.8418l15.105-15.105h-2.8398zm5.6406 0-17.906 17.906v2.8438l20.75-20.75h-2.8438zm4.1035 1.541-20.447 20.447h2.8418l17.605-17.607v-2.8398zm0 5.6406-14.805 14.807h2.8438l11.961-11.959v-2.8477zm0 5.6445-9.1621 9.1621h2.8457l6.3164-6.3184v-2.8438zm0 5.6445-3.5176 3.5176h2.8438l0.67383-0.67383v-2.8438z" />
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.background }}</span>
                    </el-menu-item>
                    <el-menu-item :class="{ active: tab === 'farben' }" :index="'farben'" class="custom" @click="navMenu('farben')" v-if="tabFarbenVisible">
                        <!-- svg icon -->
                        <svg version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path fill="currentColor" fill-rule="evenodd" d="m21.385 4.0134c-0.026811-0.76412-0.54293-1.2065-1.059-1.5193-1.593-0.92499-4.6652-1.4255-8.3249-1.4411-2.4309 0-4.6294 0.24577-6.2761 0.66134-0.82445 0.21226-1.5126 0.45803-2.0533 0.77976-0.51388 0.3128-1.0322 0.75742-1.0568 1.5193 0 0.022343 0.00447 0.042451 0.0067 0.062559h-0.00447l1.3316 16.064 0.029046 0.08937c0.11171 0.4044 1.3272 2.7549 8.021 2.7169h0.1698c6.5933 0 7.7484-2.3192 7.8557-2.7325l0.02234-0.08043 1.3316-16.058h-0.0045c0.0045-0.020108 0.01117-0.040217 0.01117-0.062559zm-2.8733 15.761c-0.19438 0.28599-1.3629 1.5997-6.5107 1.6131-3.1972 0.0022-4.8886-0.53622-5.7264-0.99425-0.42004-0.23013-0.63453-0.43792-0.73507-0.56304-0.020108-0.02458-0.037983-0.04692-0.049154-0.06479l-1.1529-13.906c1.707 0.7172 4.4596 1.1015 7.6658 1.1171 2.4287-0.00223 4.6272-0.24577 6.2738-0.66358 0.52058-0.13182 0.98084-0.28375 1.3897-0.45579zm1.2288-15.734c-0.29939 0.27705-1.3227 0.69262-2.699 0.94286-1.3808 0.26364-3.1369 0.42451-5.0405 0.42451-2.3214 0-4.4239-0.2413-5.8918-0.61219-0.73284-0.18321-1.307-0.40664-1.6355-0.60549-0.11395-0.067028-0.19662-0.13182-0.24577-0.17874 0.00894-0.00894 0.020108-0.01564 0.03128-0.026811 0.29939-0.27705 1.3227-0.69039 2.699-0.94286 1.383-0.26364 3.1391-0.42451 5.0427-0.42451 2.3192 0 4.4216 0.2413 5.8918 0.61442 0.73061 0.18544 1.3026 0.40664 1.631 0.60549 0.11395 0.067028 0.19662 0.13182 0.24577 0.17874-0.0089 0.0067-0.01787 0.01564-0.02905 0.024577z" stroke-width="0" />
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.farben }}</span>
                    </el-menu-item>
                    <el-menu-item :class="{ active: tab === 'special' }" :index="'special'" class="custom" @click="navMenu('special')" v-if="specialtab">
                        <!-- svg icon -->
                        <div v-html="specialtab.svg"></div>
                        <!-- svg icon -->
                        <span slot="title">{{ specialtab.title }} </span>
                    </el-menu-item>
                    <el-menu-item :class="{ active: tab === 'utils' }" :index="'utils'" class="custom" @click="navMenu('utils')" v-if="tabUtilsVisible">
                        <!-- svg icon -->
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" xml:space="preserve">
                        <path fill="currentColor" d="M490.667,405.333h-56.811C424.619,374.592,396.373,352,362.667,352s-61.931,22.592-71.189,53.333H21.333
                          C9.557,405.333,0,414.891,0,426.667S9.557,448,21.333,448h270.144c9.237,30.741,37.483,53.333,71.189,53.333
                          s61.931-22.592,71.189-53.333h56.811c11.797,0,21.333-9.557,21.333-21.333S502.464,405.333,490.667,405.333z M362.667,458.667
                          c-17.643,0-32-14.357-32-32s14.357-32,32-32s32,14.357,32,32S380.309,458.667,362.667,458.667z" />
                        <path fill="currentColor"
                              d="M490.667,64h-56.811c-9.259-30.741-37.483-53.333-71.189-53.333S300.736,33.259,291.477,64H21.333
                              C9.557,64,0,73.557,0,85.333s9.557,21.333,21.333,21.333h270.144C300.736,137.408,328.96,160,362.667,160
                              s61.931-22.592,71.189-53.333h56.811c11.797,0,21.333-9.557,21.333-21.333S502.464,64,490.667,64z M362.667,117.333
                              c-17.643,0-32-14.357-32-32c0-17.643,14.357-32,32-32s32,14.357,32,32C394.667,102.976,380.309,117.333,362.667,117.333z" />
                        <path fill="currentColor" d="M490.667,234.667H220.523c-9.259-30.741-37.483-53.333-71.189-53.333s-61.931,22.592-71.189,53.333H21.333
                              C9.557,234.667,0,244.224,0,256c0,11.776,9.557,21.333,21.333,21.333h56.811c9.259,30.741,37.483,53.333,71.189,53.333
                              s61.931-22.592,71.189-53.333h270.144c11.797,0,21.333-9.557,21.333-21.333C512,244.224,502.464,234.667,490.667,234.667z
                              M149.333,288c-17.643,0-32-14.357-32-32s14.357-32,32-32c17.643,0,32,14.357,32,32S166.976,288,149.333,288z" />
                  </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.utils }}</span>
                    </el-menu-item>
                    <el-menu-item :index="'help'" class="custom" @click="helpEditor" v-if="false">
                        <!-- svg icon -->
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                             xml:space="preserve">
                        <circle fill="currentColor" cx="256" cy="378.5" r="25" />
                        <path fill="currentColor" d="M256,0C114.516,0,0,114.497,0,256c0,141.484,114.497,256,256,256c141.484,0,256-114.497,256-256
                        C512,114.516,397.503,0,256,0z M256,472c-119.377,0-216-96.607-216-216c0-119.377,96.607-216,216-216
                        c119.377,0,216,96.607,216,216C472,375.377,375.393,472,256,472z" />
                        <path fill="currentColor" d="M256,128.5c-44.112,0-80,35.888-80,80c0,11.046,8.954,20,20,20s20-8.954,20-20c0-22.056,17.944-40,40-40
                        c22.056,0,40,17.944,40,40c0,22.056-17.944,40-40,40c-11.046,0-20,8.954-20,20v50c0,11.046,8.954,20,20,20
                        c11.046,0,20-8.954,20-20v-32.531c34.466-8.903,60-40.26,60-77.469C336,164.388,300.112,128.5,256,128.5z" />
                        </svg>
                        <!-- svg icon -->
                        <span slot="title">{{ language.help }}</span>
                    </el-menu-item>
                </el-menu>
            </div>
            <div class="canvas-wrapper">
                <canvas id="canvas"></canvas>
            </div>
        </div>
        <!-- ruler -->
        <div v-if="ruler"
             style="z-index:100; width: calc(100% - var(--width-left-menu)); height:auto; padding:0px; position:absolute; top:var(--height-white-bar); left: var(--width-left-menu);">
            <svg width='100%' height='20px' xmlns="http://www.w3.org/2000/svg">
                <g stroke='#eee' fill='var(--secondary-color)' stroke-width='0'
                   style='font-size: 10px; font-family: lato; font-weight: 100;'>
                    <rect width='100%' height='18' stroke-width='0' />
                    <rect :x="rulerOptions.x || 0" :width="rulerOptions.w || 0" height='18' fill='#555'
                          stroke-width='0' />
                    <path :d="rulerOptions.pathDataX" stroke-width='1' />
                    <g fill='#eee'>
                        <text v-for="(text, index) in rulerOptions.textX" :key="index" :x="text.x"
                              y="14">{{text.content}}</text>
                    </g>
                </g>
            </svg>
        </div>
        <div v-if="ruler" style="z-index:99; width: auto; height:calc(100% - var(--height-white-bar)); position:absolute; top:var(--height-white-bar); left: var(--width-left-menu);">
            <svg width='20px' height='100%' xmlns="http://www.w3.org/2000/svg">
                <g stroke='#eee' fill='var(--secondary-color)' stroke-width='0'
                   style='font-size: 10px; font-family: lato; font-weight: 100;'>
                    <rect width='18' height='100%' stroke-width='0' />
                    <rect :y="rulerOptions.y || 0" :height="rulerOptions.h || 0" width="18" fill='#555'
                          stroke-width='0' />
                    <path :d="rulerOptions.pathDataY" stroke-width='1' />
                    <g fill='#eee'>
                        <text v-for="(text, index) in rulerOptions.textY" :key="index" :y="text.y"
                              style="writing-mode: tb; glyph-orientation-vertical: 90;" x="11">{{text.content}}</text>
                    </g>
                </g>
            </svg>
        </div>
        <!-- ruler units -->
        <div class="ruler-units" style="display: none">{{this.rulerOptions.units}}</div>
        <!-- object status -->
        <div class="object-status">{{this.objectStatus}}</div>

        <!-- page dialog -->
        <el-dialog :title="language.dialogPageHeader" :visible.sync="pageDialog" :close-on-click-modal="false"
                   width="320px">
            <el-form :model="pageForm">
                <el-form-item :label="language.dialogPageWidth">
                    <el-input v-model="pageForm.width" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="language.dialogPageHeight">
                    <el-input v-model="pageForm.height" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="language.dialogPageName">
                    <el-input v-model="pageForm.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="language.dialogPageFill">
                    <el-color-picker :value="pageForm.fill" v-on:change="setPageFill($event)" style="width:100%;">
                    </el-color-picker>
                </el-form-item>
                <!--
                <el-form-item label="Upload svg">
                    <input type="file" v-on:change="pageForm.svg = $event" style="width:100%;" />
                </el-form-item>
                -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button plain @click="pageDialog = false">{{language.dialogPageCancel}}</el-button>
                <el-button type="primary" @click="addPage(pageForm); pageDialog = false">
                    {{language.dialogPageConfirm}}
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import fabric from '../canvas-modules/Fabric'
    import ImageItem from "./ImageItem";

    export default {
        name: 'Editor',
        components: { ImageItem },
        props: {
            json: String
        },
        data() {
            return {
                hostUrl: 'https://editor.alstar.ch', // 'http://localhost:3000',
                specialtab: null,
                language: {
                    cancelBtn: 'Cancel',
                    previewBtn: 'Preview',
                    saveBtn: 'Save',
                    newPage: 'New',
                    dialogPageHeader: 'Page Options',
                    dialogPageWidth: 'Width',
                    dialogPageHeight: 'Height',
                    dialogPageName: 'Name',
                    dialogPageFill: 'Fill',
                    dialogPageCancel: 'Cancel',
                    dialogPageConfirm: 'Confirm',
                    addHeadingText: 'Add heading text',
                    addSubheadingText: 'Add subheading text',
                    addBodyText: 'Add body text',
                    textFontFamily: 'Font Family',
                    textFontSize: 'Font Size',
                    textColor: 'Color',
                    textAlign: 'Text Align',
                    textTracking: 'Tracking',
                    align: 'Align',
                    layering: 'Layering',
                    group: 'Group',
                    ungroup: 'Ungroup',
                    strokeWidth: 'Stroke Width',
                    strokeColor: 'Stroke Color',
                    fillColor: 'Fill Color',
                    shapesHeader: 'Shapes',
                    cliparts: 'Cliparts',
                    clipartsHeader: 'Cliparts',
                    helperLinesHeader: 'Helper Lines',
                    gridLines: 'Grid Lines',
                    gridSize: 'Grid Size',
                    ruler: 'Ruler',
                    pages: 'Pages',
                    text: 'Text',
                    images: 'Images',
                    shapes: 'Shapes',
                    illustrations: 'Illustrationen',
                    fotos: 'Fotos',
                    background: 'Background',
                    farben: 'Farben',
                    utils: 'Utils',
                    undo: 'Undo',
                    redo: 'Redo',
                    help: 'Help',
                    centerPage: 'Center page',
                    zoomOut: 'Zoom Out',
                    zoomIn: 'Zoom In',
                    left: 'Left',
                    center: 'Center',
                    right: 'Right',
                    middle: 'Middle',
                    top: 'Top',
                    bottom: 'Bottom',
                    front: 'Front',
                    forward: 'Forward',
                    backward: 'Backward',
                    back: 'Back',
                    duplicate: 'Duplicate',
                    delete: 'Delete',
                    uploadText: 'Drop file here or',
                    uploadTextAccented: 'click to upload',
                    uploadTextSmall: 'jpg/png/svg files with a size less than 3mb',
                    helperLines: 'Helper Lines',
                    contactSupport: 'Contact Support',
                    menuHome: 'Home',
                    textTransparency: 'Transparency',
                    objectDimensions: 'Object dimensions',
                    x: 'x',
                    y: 'y',
                    w: 'width',
                    h: 'height',
                    cp_0: 'cp_0',
                    cp_1: 'cp_1',
                    cp_2: 'cp_2',
                    cp_3: 'cp_3',
                    cp_4: 'cp_4',
                    cp_5: 'cp_5',
                },
                canvas: null,
                activeSelection: null,
                isUpperCase: false,
                zoom: 100,
                activeNames: [], // ['1'],
                cliparts: [],
                fotos: [],
                backgrounds: [],
                illustrations: [],

                cp_0: [],
                cp_1: [],
                cp_2: [],
                cp_3: [],
                cp_4: [],
                cp_5: [],

                fonts: [],
                options1: [{
                    value: 10,
                    label: '10pt'
                },
                {
                    value: 20,
                    label: '20pt'
                },
                {
                    value: 30,
                    label: '30pt'
                },
                {
                    value: 40,
                    label: '40pt'
                },
                {
                    value: 50,
                    label: '50pt'
                },
                {
                    value: 60,
                    label: '60pt'
                },
                ],
                value: '',
                // experimental
                tab: null,
                loading: true,
                color: 'rgba(255, 69, 0, 0.68)',
                predefineColors: [
                    '#ff4500',
                    '#ff8c00',
                    '#ffd700',
                    '#90ee90',
                    '#00ced1',
                    '#1e90ff',
                    '#c71585',
                    'rgba(255, 69, 0, 0.68)',
                    'rgb(255, 120, 0)',
                    'hsv(51, 100, 98)',
                    'hsva(120, 40, 94, 0.5)',
                    'hsl(181, 100%, 37%)',
                    'hsla(209, 100%, 56%, 0.73)',
                    '#c7158577'
                ],
                pages: [],
                activePage: null,
                grid: false,
                gridSize: 15,
                ruler: true,
                rulerOptions: {
                    pxPerCm: 5,
                    units: '',
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                    pathDataX: '',
                    pathDataY: '',
                    textX: [],
                    textY: []
                },
                pageDialog: false,
                fontsDialog: false,
                pageForm: {
                    width: 595,
                    height: 842,
                    fill: '#ffffff',
                    name: '',
                    svg: null
                },
                objectStatus: '',
                logo: '',
                fontSizes: [],
                activeSelectionValue: '',
                shopname: '',
                helperlineBleed: 0,
                helperlineMargin: 0,
                isShowHelperLines: false,
                objectTransparensy: 100,
                backgroundFill: '#000',
                objectDimensions: {
                    left: 0,
                    top: 0,
                    width: 0,
                    height: 0
                },
                tabPagesVisible: true,
                tabFarbenVisible: false,
                tabUtilsVisible: false,
                tabBackgroundsVisible: true,
            }
        },
        methods: {
            onDrop: function (evt) {
                evt.preventDefault();
                evt.stopPropagation();

                /// this is a hack. check if target is anything LIKE "upload"
                /// and prevent uploading data twice
                var css = evt.target.getAttribute("class");
                if (css.indexOf('upload') >= 0) return false;
                /// console.log("readlupload", css);

                let files = evt.dataTransfer.files;
                if (files.length <= 0) return false;

                // console.log("od", evt, files[0]);
                this.uploadImageBase64(files[0]);

                return false;
            },
            addPage: function (options) {
                this.canvas.addPage(options, (page) => {
                    this.pages.push(page)
                    if (!this.activePage) {
                        this.setPage(0)
                    }
                })
            },
            removePage: function (index) {
                this.pages.splice(index, 1)
                this.activePage = null
                this.setPage(index - 1)
            },
            setPageFill: function (event) {
                if (event !== null) {
                    this.pageForm.fill = event
                }
            },
            setPage: function (index) {
                if (typeof this.activePage === 'number' && this.pages[this.activePage]) {
                    this.pages[this.activePage].json = this.canvas.toJSON(['evented', 'role', 'selectable', 'imgid'])
                }
                let page = index > -1 ? this.pages[index] : this.pages[0]
                this.canvas.clear()
                if (!page) return
                // ensure that width && height && fill match
                if (Array.isArray((page.json || {}).objects)) {
                    let foundPage = false
                    page.json.objects.forEach(object => {
                        if (object.role === 'page') {
                            foundPage = true
                            // handle rect case
                            if (object.type === 'rect') {
                                object.width = Number(page.width)
                                object.height = Number(page.height)
                                object.fill = page.fill
                                object.strokeWidth = 0;
                                this.backgroundFill = page.fill;
                            }
                        }
                    })
                    if (!foundPage) {
                        this.canvas._createObjectPage(page, (pageObject) => {
                            page.json.objects.unshift(pageObject)
                            this.canvas.loadPage(JSON.stringify(page.json), () => {
                                this.activePage = index
                            })
                        })
                    } else {
                        this.canvas.loadPage(JSON.stringify(page.json), () => {
                            this.activePage = index
                        })
                    }
                }
            },
            loadBase64Font(event) {
                this.canvas.loadFontBase64(event)
            },
            groupSelection: function () {
                if (!this.canvas.getActiveObject()) {
                    return
                }
                if (this.canvas.getActiveObject().type === 'activeSelection') {
                    this.canvas.getActiveObject().toGroup()
                    this.canvas.fire('selection:updated', {
                        target: this.canvas.getActiveObject()
                    })
                    this.canvas.requestRenderAll()
                    return
                }
                if (this.canvas.getActiveObject().type === 'group') {
                    this.canvas.getActiveObject().toActiveSelection()
                    this.canvas.fire('selection:updated', {
                        target: this.canvas.getActiveObject()
                    })
                    this.canvas.requestRenderAll()
                    return
                }
            },
            cloneSelection: function () {
                this.canvas.cloneSelections();
            },
            deleteSelection: function (isBackground = false) {
                // console.log("deleteSelection")
                if (isBackground) {
                    // console.log("deleteSelection bg")
                    this.canvas.getObjects().forEach(object => {
                        if (object.role === 'background') {
                            this.canvas.remove(object);
                        }
                    })
                } else {
                    // console.log("deleteSelection obj")
                    if (!this.canvas.getActiveObject()) {
                        return
                    }
                    this.canvas.remove(...this.canvas.getActiveObjects())
                    this.canvas.discardActiveObject()
                }
                this.canvas.requestRenderAll()
            },
            undo: function () {
                this.$refs.menu.activeIndex = this.tab;
                this.canvas.undo()
            },
            redo: function () {
                this.$refs.menu.activeIndex = this.tab;
                this.canvas.redo()
            },
            zoomToFit: function () {
                this.canvas.centerPage()
            },
            zoomIn: function () {
                this.canvas.zoomIn()
            },
            zoomOut: function () {
                this.canvas.zoomOut()
            },
            updateRuler: function () {
                let minTickThreshold = 50
                let pxPerCm = this.rulerOptions.pxPerCm * Math.max(this.canvas.minZoom, this.canvas.getZoom())
                if (pxPerCm <= 0 || isNaN(pxPerCm)) pxPerCm = 50
                let leftSteps = Math.ceil(this.canvas.viewportTransform[4] / pxPerCm)
                let rightSteps = Math.ceil(this.canvas.width / pxPerCm - leftSteps)
                let topSteps = Math.ceil(this.canvas.viewportTransform[5] / pxPerCm)
                let bottomSteps = Math.ceil(this.canvas.height / pxPerCm - topSteps)

                this.rulerOptions.w = this.canvas._page ? this.canvas._page.width * this.canvas._page.scaleX * this
                    .canvas.getZoom() : 0
                this.rulerOptions.h = this.canvas._page ? this.canvas._page.height * this.canvas._page.scaleY * this
                    .canvas.getZoom() : 0
                this.rulerOptions.x = this.canvas.viewportTransform[4]
                this.rulerOptions.y = this.canvas.viewportTransform[5]
                this.rulerOptions.pathDataX = ''
                this.rulerOptions.textX = []
                this.rulerOptions.pathDataY = ''
                this.rulerOptions.textY = []
                let diff = (leftSteps + rightSteps) / (this.canvas.width / minTickThreshold)
                let skipTicks = this.canvas.width / (leftSteps + rightSteps) < minTickThreshold ? [2, 2.5, 5, 10,
                    20, 30, 40, 50, 60, 70, 80, 90,
                    100, 110, 120, 130, 140, 150, 200, 250, 300
                ].reduce((prev, curr) => Math.abs(curr - diff) < Math.abs(prev - diff) ? curr : prev) : 1

                if (leftSteps > 0) {
                    for (let i = 0; i <= leftSteps; i += skipTicks) {
                        let posX = this.canvas.viewportTransform[4] - i * pxPerCm
                        this.rulerOptions.pathDataX += ` M ${posX} 3 L ${posX} 18`
                        this.rulerOptions.textX.push({
                            x: posX + 3,
                            content: -i
                        })
                    }
                }
                if (rightSteps > 0) {
                    for (let i = 0; i <= rightSteps; i += skipTicks) {
                        let posX = this.canvas.viewportTransform[4] + i * pxPerCm
                        this.rulerOptions.pathDataX += ` M ${posX} 3 L ${posX} 18`
                        this.rulerOptions.textX.push({
                            x: posX + 3,
                            content: i
                        })
                    }
                }
                if (topSteps > 0) {
                    for (let i = 0; i <= topSteps; i += skipTicks) {
                        let posY = this.canvas.viewportTransform[5] - i * pxPerCm
                        this.rulerOptions.pathDataY += ` M 3 ${posY} L 18 ${posY}`
                        this.rulerOptions.textY.push({
                            y: posY + 3,
                            content: -i
                        })
                    }
                }
                if (bottomSteps > 0) {
                    for (let i = 0; i <= bottomSteps; i += skipTicks) {
                        let posY = this.canvas.viewportTransform[5] + i * pxPerCm
                        this.rulerOptions.pathDataY += ` M 3 ${posY} L 18 ${posY}`
                        this.rulerOptions.textY.push({
                            y: posY + 3,
                            content: i
                        })
                    }
                }
            },
            sliderZoom: function (value) {
                if (this.canvas) {
                    this.canvas.zoomTo(value / 100)
                }
            },
            helpEditor: function () {
                this.$refs.menu.activeIndex = this.tab;
                if (window.parent) {
                    window.parent.postMessage({
                        help: true
                    }, '*')
                }
            },
            closeEditor: function () {
                if (window.parent) {
                    window.parent.postMessage({
                        close: true
                    }, '*')
                }
            },
            previewEditor: function () {
                if (typeof this.activePage === 'number' && this.pages[this.activePage]) {
                    this.pages[this.activePage].json = this.canvas.toJSON(['evented', 'role', 'selectable', 'imgid'])
                }
                if (window.parent) {
                    window.parent.postMessage({
                        preview: true,
                        pages: this.pages,
                        svg: this.canvas.toSVG2(),
                        previewPage: this.activePage,
                    }, '*')
                }
            },
            exportDrawing: function () {
                if (typeof this.activePage === 'number' && this.pages[this.activePage]) {
                    this.pages[this.activePage].json = this.canvas.toJSON(['evented', 'role', 'selectable', 'imgid']);
                }

                /// create svg of first page
                let canvas = new fabric.Canvas(null, { width: 1000, height: 1000 })
                canvas.loadPage(this.pages[0].json, () => {
                    let svg = canvas.toSVG2()
                    //let png = canvas.toDataURL('png')
                    canvas.clear()
                    canvas.dispose()
                    if (window.parent) {
                        window.parent.postMessage({
                            save: true,
                            pages: this.pages,
                            previewPage: this.activePage,
                            svg: svg,
                            // png: png
                        }, '*')
                    }
                })
            },
            getTextContent(file) {
                return new Promise(function (resolve, reject) {
                    let reader = new FileReader();
                    let imgResult = "";
                    reader.onload = function () {
                        imgResult = reader.result;
                    };
                    reader.onerror = function (error) {
                        reject(error);
                    };
                    reader.onloadend = function () {
                        resolve(imgResult);
                    };
                    reader.readAsText(file);
                });
            },
            getBase64(file) {
                return new Promise(function (resolve, reject) {
                    let reader = new FileReader();
                    let imgResult = "";
                    reader.readAsDataURL(file);
                    reader.onload = function () {
                        imgResult = reader.result;
                    };
                    reader.onerror = function (error) {
                        reject(error);
                    };
                    reader.onloadend = function () {
                        resolve(imgResult);
                    };
                });
            },
            addClipart: function (url, event) {
                this.canvas.addClipart(url)
                event.preventDefault()
            },
            uploadImageBase64: function (file) {

                if (file.type === "application/json") {
                    this.getTextContent(file).then(res => {

                        // original - first page only
                        //
                        //var pageIx = this.activePage;
                        //var page0 = JSON.parse(res)[0];
                        //this.pages[pageIx] = Object.assign(page0);
                        //this.activePage = null;
                        //this.setPage(pageIx)

                        // new - this is like loading the page for the first time
                        //console.log("f0")
                        var pages = JSON.parse(res);
                        //console.log("f1", pages)
                        this.canvas.clear()
                        this.activePage = null
                        this.pages = pages
                        this.loadedFonts.then(() => {
                            //console.log("f2")
                            this.setPage(0)
                        })


                    })
                    return;
                }

                if (file.type === "application/pdf") {
                    this.getBase64(file).then(res => {

                        fetch('https://srv.cardprint.ch/pdf/rasterizepdf?j=1', { method: "POST", body: res, headers: { 'x-maxwidthpx': 2000, 'apikey': '33ff939d-f6aa-464e-8d6c-53664c1fd971' } }).then(r => r.json())
                            .then(json => {
                                var imgId = this.canvas.addImage("data:image/png;base64," + json.b64);
                                if (window.parent) {
                                    window.parent.postMessage({
                                        pdfupload: true,
                                        imgId: imgId,
                                        imageBase64: json.b64,
                                        pdfBase64: res
                                    }, '*')
                                }
                            }
                            );

                    });
                    return;
                }

                this.getBase64(file).then(res => {
                    var imgId = this.canvas.addImage(res);

                    if (window.parent) {
                        window.parent.postMessage({
                            imageupload: true,
                            imgId: imgId,
                            imageBase64: res
                        }, '*')
                    }

                })
            },
            uploadSvgBase64: function (file) {
                this.getBase64(file).then(res => {
                    this.canvas.addSvg(res)
                })
            },
            addCircle: function () {
                this.canvas.addCircle()
            },
            addTriangle: function () {
                this.canvas.addTriangle()
            },
            addRect: function () {
                this.canvas.addRect()
            },
            addEllipse: function () {
                this.canvas.addEllipse()
            },
            //addPath: function () {
            //    this.canvas.addPath("m8.5231-5e-8c-0.84127 0-1.523 0.68167-1.523 1.523v0.47708h-2.8162c-1.2063 0-2.184 0.97771-2.184 2.184v17.632c0 1.2063 0.97771 2.184 2.184 2.184h15.632c1.2063 0 2.184-0.97771 2.184-2.184v-17.632c-4.7e-5 -1.2063-0.9778-2.184-2.1841-2.184h-2.8157v-0.47708c0-0.84131-0.68176-1.523-1.5231-1.523zm0.47699 2.0001h5.9998v2h-5.9998zm8.0001 1.9999h2.8158c0.10172 0 0.18402 0.082302 0.18402 0.18402v17.632c0 0.10172-0.0823 0.18393-0.18402 0.18393h-15.632c-0.10172 0-0.18402-0.08221-0.18402-0.18393v-17.632c0-0.10172 0.0823-0.18402 0.18402-0.18402h2.816v0.47699c0 0.84127 0.68167 1.5231 1.523 1.5231h6.9543c0.84127 0 1.523-0.68176 1.523-1.5231zm-1.8344 3.9999c-0.44868 0-0.89737 0.17117-1.2396 0.51343l-5.766 5.7671c-0.11967 0.11972-0.20709 0.26782-0.25388 0.43048l-0.867 3.013c-0.21745 0.75572 0.48221 1.4552 1.2379 1.2374l3.0121-0.86801c0.16252-0.04683 0.31049-0.13421 0.43012-0.25378l5.767-5.766c0.68456-0.68456 0.68452-1.7947 0-2.4792l-1.081-1.081c-0.34226-0.34226-0.79095-0.51343-1.2396-0.51343zm0 2.1022 0.73178 0.73178-5.4099 5.409-1.0261 0.29562 0.29544-1.0266z")
            //},
            addPath: function (path) {

                fetch(path)
                    .then(r => r.text())
                    .then(r => {
                        var parser = new DOMParser();
                        var doc = parser.parseFromString(r, "image/svg+xml");
                        var svgpath = doc.documentElement.firstElementChild.attributes["d"].nodeValue;
                        this.canvas.addPath(svgpath);
                    })

            },
            addText: function (options) {
                this.canvas.addText(options)

                this.activeSelectionValue = Number(options.fontSize);
            },
            setLayer: function (layer) {
                this.canvas.positionActiveObject(layer)
                this.canvas.requestRenderAll()
            },
            setAlign: function (align) {
                this.canvas.alignActiveObject(align)
                this.canvas.requestRenderAll()
            },
            setStyle: function (style) {
                if (!this.activeSelection) return;

                this.isFontSize(style, 'fontSize');

                for (const property in style) {
                    if (style[property] === null) {
                        delete style[property]
                    }
                }
                this.canvas.getActiveObject().set(style)
                if (this.canvas.getMissingFonts().length > 0 && style.fontFamily) {
                    this.canvas.fire('missing:fonts', this.canvas.getMissingFonts())
                }
                this.canvas.fire('object:modified', {
                    target: this.canvas.getActiveObject()
                })
                this.canvas.requestRenderAll()
            },
            setGrid: function () {
                this.canvas.grid = this.grid
                this.canvas.requestRenderAll()
            },
            setGridSize: function (value) {
                this.gridSize = Number(value)
                this.canvas.gridSize = this.gridSize
                this.canvas.requestRenderAll()
            },
            navMenu: function (tab) {
                if (this.tab != tab)
                    this.activeNames = '';
                if (tab === "shapes")
                    this.activeNames = ['0', '1']; /// is this  a hack?
                this.tab = this.tab === tab ? null : tab;
                if (this.canvas) {
                    this.canvas.discardActiveObject()
                    this.canvas.requestRenderAll()
                }
            },
            isFontSize(style, type) {
                if (Object.prototype.hasOwnProperty.call(style, type)) {
                    this.$set(this.activeSelection, type, this.activeSelectionValue);
                }
            },
            getCliparts() {
                fetch(`${this.hostUrl}/api/media/${this.shopname}`).then((response) => {
                    return response.json()
                }).then((result) => {
                    /// console.log("fetcho", result)
                    this.cliparts = result.cliparts;
                    this.fotos = result.fotos;
                    this.backgrounds = result.backgrounds;
                    this.illustrations = result.illustrations;

                    this.backgrounds = result.backgrounds;

                    // this.cliparts = result.cp_0;
                    // this.fotos = result.cp_1;
                    // this.illustrations = result.cp_2;

                    this.cp_0 = result.cp_0;
                    this.cp_1 = result.cp_1;
                    this.cp_2 = result.cp_2;
                    this.cp_3 = result.cp_3;
                    this.cp_4 = result.cp_4;
                    this.cp_5 = result.cp_5;
                    //    this.cp_6 = result.cp_6;
                })
            },
            getRightName(name) {
                let result = name.split('_');
                return result.length > 1 ? result[1] : name;
            },
            setHelperLines(show) {
                //console.log("setHelperLines", show);
                this.isShowHelperLines = !this.isShowHelperLines;
                /// either toggle or explicitly set
                if (show === true || show === false)
                    this.isShowHelperLines = show;
                this.canvas.helperLine = this.isShowHelperLines;
                this.canvas.paddingDistanse = this.helperlineMargin;
                this.canvas.marginDistanse = this.helperlineBleed;
                this.canvas.pxPerCm = this.rulerOptions.pxPerCm; // * Math.max(this.canvas.minZoom, this.canvas.getZoom());
                this.canvas.requestRenderAll();
            },
            home() {
                if (window.parent) {
                    window.parent.postMessage({
                        home: true
                    }, '*')
                }
            },
            contactSupport() {
                if (window.parent) {
                    window.parent.postMessage({
                        support: true
                    }, '*')
                }
            },
            setPageBackground(event, url = null) {
                if (url !== null) {
                    var xxx = document.getElementById('cotw');
                    xxx.style.display = 'block';
                    this.canvas.loadPageBackgroundImage(url, function () { xxx.style.display = 'none'; })
                } else {
                    let activePage = this.pages[this.activePage];
                    activePage.fill = event;
                    activePage.json.objects[0].fill = event;
                    this.setPage(this.activePage)
                }
            },
            changeObjectDimensions() {
                if (this.activeSelection === null) {
                    return;
                }
                let objectDimensions = this.getObjectDimensions();
                if (objectDimensions) {
                    this.canvas.changeObjectDimensions(objectDimensions);
                    this.canvas.requestRenderAll();
                }
            },
            getObjectDimensions() {
                if (this.activeSelection === null) {
                    return;
                }

                let objectDimensions = {
                    left: this.objectDimensions.left,
                    top: this.objectDimensions.top
                }
                if (this.activeSelection.type !== 'InteractiveText') {
                    objectDimensions.scaleX = this.objectDimensions.width / this.activeSelection.width;
                    objectDimensions.scaleY = this.objectDimensions.height / this.activeSelection.height;
                }
                return objectDimensions;
            },
            setObjectDimensions(defaultActiveSelection = null) {
                let { left, top, width, height } = defaultActiveSelection === null ? this.activeSelection : defaultActiveSelection;
                return { left: left, top: top, width: width * this.activeSelection.scaleX, height: height * this.activeSelection.scaleY };
            },
            handleChangeTop(currentValue, oldValue) {
                this.changeNextTick('top', currentValue, oldValue);
            },
            handleChangeLeft(currentValue, oldValue) {
                this.changeNextTick('left', currentValue, oldValue);
            },
            handleChangeHeight(currentValue, oldValue) {
                this.changeNextTick('height', currentValue, oldValue);
            },
            handleChangeWidth(currentValue, oldValue) {
                this.changeNextTick('width', currentValue, oldValue);
            },
            changeNextTick(element, currentValue, oldValue) {
                if (currentValue === undefined) {
                    this.$nextTick(() => {
                        this.objectDimensions[element] = oldValue
                    });
                } else {
                    this.objectDimensions[element] = currentValue * this.rulerOptions.pxPerCm;// *  this.canvas.getZoom())
                }
            },
            imageClick(event, source) {
                if (this.tab === 'backgrounds') {
                    this.setPageBackground(event, source)
                } else {
                    this.addClipart(source, event)
                }
            }

            //   getFonts(){
            //     this.loadedFonts = new Promise((resolve) => {
            //       fetch(`${this.hostUrl}/api/fonts/${this.shopname}`).then((response) => {
            //         return response.json()
            //       }).then((result) => {
            //         if (Array.isArray(result)) {
            //           result.forEach(family => {
            //             this.fonts.push(...family.fonts)
            //           })
            //         }
            //         resolve()
            //       })
            //     })
            //   }
        },
        mounted() {
            this.loading = false
            this.canvas = new fabric.Canvas('canvas', {
                fireMiddleClick: true,
                skipOffscreen: true,
                preserveObjectStacking: true,
            })
            this.canvas.loadDefaultFont()
            setInterval(() => {
                this.canvas.renderCanvas(this.canvas.contextContainer, this.canvas._objects)
            }, 250)
            this.canvas.initKeyEvents()
            this.canvas.on('object:modified', (selection) => {
                this.activeSelection = typeof selection.target.getUIStyles ==
                    'function' ? selection
                        .target.getUIStyles() : selection.target;
            })
            this.canvas.on('selection:created', (selection) => {
                this.activeSelection = typeof selection.target.getUIStyles ==
                    'function' ? selection
                        .target.getUIStyles() : selection.target
                if (!this.tab) {
                    this.tab = this.canvas.getTab(selection.target)
                }
                this.objectTransparensy = this.activeSelection.opacity === "Mixed" ? 100 : this.activeSelection.opacity * 100
                this.objectDimensions = this.setObjectDimensions();
            })
            this.canvas.on('selection:updated', (selection) => {
                this.activeSelection = typeof selection.target.getUIStyles ==
                    'function' ? selection
                        .target.getUIStyles() : selection.target
                if (!this.tab) {
                    this.tab = this.canvas.getTab(selection.target)
                }
                this.objectTransparensy = this.activeSelection.opacity === "Mixed" ? 100 : this.activeSelection.opacity * 100
            })
            this.canvas.on('text:selection:changed', (selection) => {
                this.activeSelection = typeof selection.target.getUIStyles ==
                    'function' ? selection
                        .target.getUIStyles() : selection.target
                if (!this.tab) {
                    this.tab = this.canvas.getTab(selection.target)
                }
                this.objectTransparensy = this.activeSelection.opacity === "Mixed" ? 100 : this.activeSelection.opacity * 100
            })
            this.canvas.on('selection:cleared', () => {
                this.activeSelection = null;
                this.objectTransparensy = 100;
            })
            this.canvas.on('zoom:changed', () => {
                this.zoom = Number((this.canvas.getZoom() * 100).toFixed(0))
                this.updateRuler()
            })
            this.canvas.on('missing:fonts', (fonts) => {
                fonts.forEach(mFont => {
                    let fontMatch = this.fonts.filter(font => font.name === mFont)[0]
                    if (fontMatch) {
                        let url = fontMatch.url
                        fetch(`${this.hostUrl}/${url}`).then((response) => {
                            return response.arrayBuffer()
                        }).then((buffer) => {
                            this.canvas.loadFont(buffer, mFont)
                        })
                    }
                })
            })

            this.canvas.on('object:moving', (opt) => {
                this.objectDimensions = this.setObjectDimensions(opt.target);
            })
            this.canvas.on('object:scaling', (opt) => {
                this.objectDimensions = this.setObjectDimensions();

                if (this.activeSelection.type === 'InteractiveText') {
                    if (this.activeSelection.fontSize === 'Mixed') {
                        this.activeSelectionValue = 'Mixed'
                    } else {
                        this.activeSelectionValue = (opt.target.scaleX * this.activeSelection.fontSize).toFixed(1);
                    }

                }
            });

            this.canvas.initResponsive(document.getElementsByClassName('canvas-wrapper')[0])
            this.addPage({
                width: 595,
                height: 842,
                fill: '#ffffff',
                name: ''
            })

            window.addEventListener('message', (event) => {
                // TODO: verify event.origin to prevent client xss
                // if (event.origin !== window.location.origin) {
                if (event.data) {
                    let data = event.data
                    if (data.addimage) {
                        this.canvas.addImage(data.base64, data.name, data.ix);
                        return;
                    }
                    if (data.pages && !data.fixjson) {
                        this.canvas.clear()
                        this.activePage = null
                        this.pages = data.pages
                        this.loadedFonts.then(() => {
                            this.setPage(0)
                        })
                    }
                    // console.log("a0", data.tabBackgroundsVisible !== undefined)
                    if (data.tabBackgroundsVisible !== undefined)
                        this.tabBackgroundsVisible = data.tabBackgroundsVisible
                    if (data.specialtab) {
                        this.specialtab = data.specialtab;
                        var html = data.specialtab.content;
                        var elm = document.getElementById('__cs');
                        if (!elm) { elm = document.createElement('div'); elm.id = '__cs'; elm.style.display = 'none'; document.body.appendChild(elm); }
                        elm.innerHTML = html;

                        /// this is to execute any scripts if injected this way.
                        Array.from(elm.querySelectorAll("script")).forEach(oldScript => {
                            const newScript = document.createElement("script");
                            Array.from(oldScript.attributes)
                                .forEach(attr => newScript.setAttribute(attr.name, attr.value));
                            newScript.appendChild(document.createTextNode(oldScript.innerHTML));
                            oldScript.parentNode.replaceChild(newScript, oldScript);
                        });

                        this.navMenu('special');
                    }
                    if (data.css) {
                        // we expect it's name without extension
                        fetch(`${this.hostUrl}/${data.css}.css`).then((response) => {
                            return response.text()
                        }).then((result) => {
                            let style = document.createElement('style')
                            style.innerText = result
                            document.head.appendChild(style)
                        })
                    }
                    if (data.language) {
                        // we expect it's name without extension
                        fetch(`${this.hostUrl}/${data.language}.json`).then((response) => {
                            return response.json()
                        }).then((result) => {
                            this.language = result
                        })
                    }
                    if (data.pxPerCm) {
                        this.rulerOptions.pxPerCm = Number(data.pxPerCm)
                    }
                    if (data.units) {
                        this.rulerOptions.units = data.units
                    }
                    if (data.objectStatus) {
                        this.objectStatus = data.objectStatus
                    }
                    if (data.logo) {
                        this.logo = data.logo
                    }
                    if (data.shopname) {
                        this.shopname = data.shopname;
                        this.getCliparts();
                    }
                    if (data.helperlineMargin) {
                        this.helperlineMargin = Number(data.helperlineMargin);
                    }
                    if (data.helperlineBleed) {
                        this.helperlineBleed = Number(data.helperlineBleed);
                    }
                    if (data.init) {
                        this.tabPagesVisible = data.tabPagesVisible
                        // this.tabFarbenVisible = data.tabFarbenVisible
                        this.tabUtilsVisible = data.tabUtilsVisible
                        this.tabBackgroundsVisible = data.tabBackgroundsVisible
                    }
                    if (data.fixjson) {
                        let promises = [];
                        let canvas = null;
                        if (data.pages.length >= 0) {
                            data.pages.forEach(page => {
                                let foundPage = false
                                page.json.objects.forEach(object => {
                                    if (object.role === 'page') {
                                        foundPage = true
                                        // handle rect case
                                        if (object.type === 'rect') {
                                            object.width = Number(page.width)
                                            object.height = Number(page.height)
                                            object.fill = page.fill
                                        }
                                    }
                                })
                                if (!foundPage) {
                                    if (canvas === null)
                                        canvas = new fabric.Canvas(null, { width: 1000, height: 1000 })
                                    var promise = new Promise((resolve) => { canvas._createObjectPage(page, (pageObject) => { page.json.objects.unshift(pageObject); resolve(); }) })
                                    promises.push(promise);
                                }
                            })
                        }

                        Promise.all(promises).then(function () {
                            if (canvas) {
                                canvas.clear()
                                canvas.dispose()
                                canvas = null
                            }
                        })



                        this.loadedFonts.then(() => {
                            // console.log("zanog", data.pages[0])
                            /// create svg of first page
                            let c2 = new fabric.Canvas(null, { width: 1000, height: 1000 })
                            c2.loadPage(data.pages[0].json, () => {
                                var svg = c2.toSVG2()
                                c2.clear()
                                c2.dispose()
                                event.source.postMessage({ fixjson: true, svg: svg }, event.origin);
                            })
                        })

                    }

                    /// just show them
                    this.setHelperLines(true);
                }
            }, false)

            if (this.shopname.length === 0) {
                this.shopname = 'pipo';
                this.getCliparts();
            }
            this.loadedFonts = new Promise((resolve) => {
                fetch(`${this.hostUrl}/api/fonts`).then((response) => {
                    return response.json()
                }).then((result) => {
                    if (Array.isArray(result)) {
                        result.forEach(family => {
                            this.fonts.push(...family.fonts)
                        })
                    }
                    resolve()
                })

            })

            this.fontSizes = Array.from(Array(61).keys(), n => n * 2).slice(1);

            this.navMenu("text");
        },
        computed: {
            activeTab() {
                return typeof this.activePage === 'number' && !this.activeSelection;
            },
            arrayFromTab() {
                var isClipartTab = ['backgrounds', 'cliparts', 'fotos', 'illustrations', 'cp_0', 'cp_1', 'cp_2', 'cp_3', 'cp_4', 'cp_5'].indexOf(this.tab) >= 0;
                if (!isClipartTab) return [];
                var ret = this[this.tab];
                return ret;
            },
            objectDimensionsPerCm() {
                let pxPerCm = this.rulerOptions.pxPerCm;// * this.canvas.getZoom();
                return {
                    left: this.objectDimensions.left / pxPerCm,
                    top: this.objectDimensions.top / pxPerCm,
                    width: this.objectDimensions.width / pxPerCm,
                    height: this.objectDimensions.height / pxPerCm,
                }
            }
        }
    }
</script>

<style>
    :root { --width-left-menu: 100px; --very-ligth-gray: #EDEDED; --height-white-bar: 100px; --menu-ligth-gray: #4d4d4d; --primary-color: #3d87a6; --secondary-color: #4d4d4d; --colapse-primary: #d4d4d4; /* #4597ba; /* #3d87a6; */ --colapse-primary-light: #c00; /* #57a1c1; /* #4597ba; */ --colapse-primary-text: #fff; --active-slider-bar: #3d40a6; }

    .editor { background: #7f7f7f; }

    .container { display: flex; flex-direction: row; height: calc(100vh - var(--height-white-bar)); }

    .canvas-wrapper { flex: 1; width: 100%; height: 100%; overflow: hidden; }

    .menu { flex: 0 0 50px; background: #3f414c; box-shadow: 0 2px 0.26rem rgba(30, 32, 36, .8); color: var(--menu-ligth-gray); display: flex; flex-direction: column; justify-content: flex-start; z-index: 102; user-select: none; }

        .menu div { display: flex; justify-content: center; align-content: center; width: 100%; height: 50px; font-size: 20pt; cursor: pointer; transition: all .15s ease-in-out; }

            .menu div > svg { width: 28px; height: auto; }

    .menu-tab { display: flex; flex-direction: column; align-items: center; position: absolute; top: var(--height-white-bar); left: var(--width-left-menu); max-width: 290px; width: 100%; _height: calc(100vh - 100px); color: #b6b6b6; _background: #2d2e37; background: var(--primary-color); z-index: 101; user-select: none; overflow-y: auto; overflow-x: hidden; }
    .menu-tab { height: calc(100vh - 120px); _overflow: hidden; }

    .zoom { position: absolute; z-index: 100; right: 0; bottom: 2vh; display: flex; flex-direction: row; justify-content: center; width: calc(100vw - var(--width-left-menu)); }

    .pages-menu { position: absolute; z-index: 100; left: 100px; _right: 0; margin: 0 auto; bottom: calc(2vh + 50px); display: flex; flex-direction: row; flex-wrap: wrap; justify-content: center; _width: calc(100vw - var(--width-left-menu)); width: calc(100vw - 800px); }
        .pages-menu > .el-button { margin-bottom: 10px; padding: 6px; font-size: 10px; }

    .tab { padding: 20px 20px 0px 20px; display: flex; flex-direction: column; width: calc(100% - 40px); }

    .shapes-container-div svg, .shapes-container-div img { cursor: pointer; transition: all .15s ease-in-out; }
        .shapes-container-div svg:hover, .shapes-container-div img:hover { opacity: 0.8; }

    .page-item { width: 100%; max-width: 90px; height: 100px; background: #fff; margin-bottom: 20px; outline: 2px solid transparent; cursor: pointer; }

    .page-content { display: flex; justify-content: center; align-items: center; color: #1e2024; height: 100%; width: 100%; }

    .active-page { outline: 2px solid var(--primary-color); }

    .el-color-dropdown__btns button:last-child { color: #FFF; background-color: var(--primary-color); border-color: var(--primary-color) }

        .el-color-dropdown__btns button:last-child:hover { background-color: var(--primary-color); border-color: var(--primary-color); opacity: 0.7; color: #FFF }

        .el-color-dropdown__btns button:last-child:focus { background-color: var(--primary-color); border-color: var(--primary-color); opacity: 0.7; color: #FFF }

    .clipart-image { cursor: pointer; }

        .clipart-image:hover { opacity: 0.7; }

    .font-item { min-height: 50px; display: flex; align-items: center; cursor: pointer; }

        .font-item:hover { color: #fff; }

        .font-item svg { width: 100%; height: auto; }

    .close-fonts { cursor: pointer; font-size: 14pt; }

        .close-fonts:hover { opacity: 0.7; }

    .font-select { max-width: 100%; overflow: hidden; text-align: right; font-size: 10pt; cursor: pointer; color: #EDEDED; white-space: nowrap; }

        .font-select:hover { color: #fff; }

    .fonts-dialog { width: 100%; color: #b6b6b6; background: #2d2e37; z-index: 1100; position: absolute; padding-bottom: 20px; }
    .fonts-dialog-header { width: calc(100%-20px); height: 30px; display: flex; padding-right: 20px; padding-top: 10px; justify-content: flex-end; align-items: center; }
    .fonts-dialog-items { width: calc(100% - 60px); _height: calc(100vh - 40px); height: calc(100vh - 180px); overflow-y: auto; padding: 0px 20px 0px 20px; }

    .ruler-units { position: absolute; z-index: 100; right: 20px; top: 20px; color: #fff; font-size: 14pt; }
    .object-status { position: absolute; z-index: 100; bottom: 100px; right: 20px; color: #fff; font-size: 14pt; }

    .cliparts-all { display: flex; flex-flow: row wrap; }
    .clipart-item { _width: 80px; _height: 80px; width: 50px; height: 50px }
    .clipart-one { _width: 50%; width: 33.3%; display: flex; justify-content: center; margin-bottom: 10px; }

    .d_flex_center { display: flex; align-items: center; justify-content: center; }

    .custom:not(browser-default) { display: flex; flex-direction: column; line-height: 20px; align-items: center; height: 70px; padding: 10px 10px !important; }
    .custom.active { _background-color: var(--primary-color) !important; background-color: #7f7f7f !important; }
    .menu { background-color: var(--secondary-color); }
        .menu .el-menu:not(browser-default) { border-right: unset; width: var(--width-left-menu); }
    .el-menu-item span { font-size: 10px; font-weight: bold; text-transform: uppercase; }

    /*.el-menu-item {*/
    /*  color: #fff !important;*/
    /*}*/

    .el-menu-item:hover, .el-menu-item:focus { color: #fff !important; background-color: var(--primary-color); }

    .white-bar { height: var(--height-white-bar); width: auto; background: white; display: flex; align-items: center; justify-content: space-between; }

    .horizontal-menu { display: flex; align-items: center; justify-content: space-between; width: 100%; }

        .horizontal-menu .el-menu:not(browser-default) { border-bottom: unset; }

    .el-menu--horizontal { width: 50%; display: flex; align-items: center; justify-content: center; }

        .el-menu--horizontal span { font-size: 13px; padding-left: 5px; color: var(--menu-ligth-gray) }
        .el-menu--horizontal .el-menu-item:not(browser-default) { height: 40px; min-width: 100px; line-height: 40px; color: var(--menu-ligth-gray); }

        .el-menu--horizontal .el-menu-item:hover { color: #3f414c !important; }

        .el-menu--horizontal svg { height: 19px; fill: var(--menu-ligth-gray); }

    .export { width: 30%; }

    .editor-logo { width: 30%; padding-left: 25px; }
        .editor-logo img { max-height: 65px; user-select: none; }

    .active-tab-row { margin-bottom: 10px; border-bottom: 1px solid #373842; align-items: center; padding-bottom: 10px; }

        .active-tab-row .tab-col { font-size: 10pt; color: var(--very-ligth-gray); }
    .el-input-number--small { width: 75px; padding-left: 10px; padding-right: 10px; }

    .el-input--small .el-input__inner { padding-left: 10px !important; padding-right: 10px !important; }

    .el-slider__bar { background-color: var(--active-slider-bar); }

    @media (max-width: 1280px) {
        .export .el-button, .el-menu--horizontal .el-menu-item { padding-left: 10px; padding-right: 10px; }
        .horizontal-menu .el-menu--horizontal .el-menu-item { min-width: 50px; }
        .editor-logo { width: 15%; }
        .export:not(browser-default) { width: 70%; }

        .el-collapse { overflow-x: auto; }

        /*.menu { background-color: var(--secondary-color); }*/
        /*.menu .el-menu { background-color: var(--secondary-color); }*/
        /*.el-collapse { border-top-color: var(--colapse-primary); _border-bottom-color: var(--colapse-primary); }*/
        /*.el-collapse-item__header { color: #fff; background: var(--colapse-primary); border-bottom-color: var(--colapse-primary-light); }*/
        /*.el-collapse-item__wrap { background-color: var(--colapse-primary); border-bottom-color: var(--colapse-primary-light); }*/
    }

    @media (max-width: 1024px) {
        .horizontal-menu .el-menu--horizontal { display: none; }
    }

    .el-upload__tip { color: #ffffff; }

    .el-collapse-item__content { max-height: 300px; _background: #c00; }

    .dropdown-menu-divider { border-bottom: 1px solid #aaaaaa; margin: 0 auto 10px auto !important; height: 1px !important; width: 80% !important; }

    .menu-tab { background-color: #7f7f7f; border-right: 1px solid #4d4d4d; }
</style>
